import { emptySplitApi as api } from './baseApi';
export const addTagTypes = [
  'Auth',
  'BedTypeController',
  'BoatEquipmentController',
  'BoatController',
  'BoatExtraOptionController',
  'ExperienceController',
  'PropertyController',
  'ReviewController',
  'BookingController',
  'CategoryController',
  'ContentController',
  'ConversationController',
  'CronController',
  'ExchangeRateController',
  'ExtraOptionTypeExtraOptionCategoryController',
  'FaqController',
  'FeedController',
  'LocationController',
  'MediaController',
  'MessageController',
  'PasswordResetRequestController',
  'PayoutDetailsController',
  'PingController',
  'PortController',
  'RouteController',
  'EmailLogController',
  'SkipperController',
  'StripeConnectController',
  'StripeWebhookController',
  'UserController',
  'UserConsentController',
  'VehicleController',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAuthMagic: build.query<GetAuthMagicApiResponse, GetAuthMagicApiArg>({
        query: (queryArg) => ({
          url: `/auth/magic`,
          params: {
            token: queryArg.token,
          },
        }),
        providesTags: ['Auth'],
      }),
      getBedTypesById: build.query<
        GetBedTypesByIdApiResponse,
        GetBedTypesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bed-types/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['BedTypeController'],
      }),
      getBedTypes: build.query<GetBedTypesApiResponse, GetBedTypesApiArg>({
        query: (queryArg) => ({
          url: `/bed-types`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['BedTypeController'],
      }),
      getBoatEquipment: build.query<
        GetBoatEquipmentApiResponse,
        GetBoatEquipmentApiArg
      >({
        query: (queryArg) => ({
          url: `/boat-equipment`,
          params: {
            bookableTypes: queryArg.bookableTypes,
          },
        }),
        providesTags: ['BoatEquipmentController'],
      }),
      getBoatsAvailable: build.query<
        GetBoatsAvailableApiResponse,
        GetBoatsAvailableApiArg
      >({
        query: () => ({ url: `/boats/available` }),
        providesTags: ['BoatController'],
      }),
      getBoatsCount: build.query<GetBoatsCountApiResponse, GetBoatsCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/boats/count`,
            params: {
              limit: queryArg.limit,
              offset: queryArg.offset,
              order: queryArg.order,
              desc: queryArg.desc,
              featured: queryArg.featured,
              category: queryArg.category,
              minLength: queryArg.minLength,
              maxLength: queryArg.maxLength,
              minRate: queryArg.minRate,
              maxRate: queryArg.maxRate,
              currencyCode: queryArg.currencyCode,
              latlng: queryArg.latlng,
              distance: queryArg.distance,
              location: queryArg.location,
              'location.division': queryArg['location.division'],
              port: queryArg.port,
              numberOfPeople: queryArg.numberOfPeople,
              numberOfCabins: queryArg.numberOfCabins,
              startDate: queryArg.startDate,
              endDate: queryArg.endDate,
            },
          }),
          providesTags: ['BoatController'],
        }
      ),
      postBoatsDenyById: build.mutation<
        PostBoatsDenyByIdApiResponse,
        PostBoatsDenyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/deny/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['BoatController'],
      }),
      getBoatsLocations: build.query<
        GetBoatsLocationsApiResponse,
        GetBoatsLocationsApiArg
      >({
        query: () => ({ url: `/boats/locations` }),
        providesTags: ['BoatController'],
      }),
      getBoatsManagerBoats: build.query<
        GetBoatsManagerBoatsApiResponse,
        GetBoatsManagerBoatsApiArg
      >({
        query: () => ({ url: `/boats/manager-boats` }),
        providesTags: ['BoatController'],
      }),
      getBoatsUnverified: build.query<
        GetBoatsUnverifiedApiResponse,
        GetBoatsUnverifiedApiArg
      >({
        query: () => ({ url: `/boats/unverified` }),
        providesTags: ['BoatController'],
      }),
      getBoatsVerifiedManagerWithBookings: build.query<
        GetBoatsVerifiedManagerWithBookingsApiResponse,
        GetBoatsVerifiedManagerWithBookingsApiArg
      >({
        query: () => ({ url: `/boats/verified-manager-with-bookings` }),
        providesTags: ['BoatController'],
      }),
      postBoatsVerifyById: build.mutation<
        PostBoatsVerifyByIdApiResponse,
        PostBoatsVerifyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/verify/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['BoatController'],
      }),
      postBoatsByIdExtraOptions: build.mutation<
        PostBoatsByIdExtraOptionsApiResponse,
        PostBoatsByIdExtraOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/${queryArg.id}/extra-options`,
          method: 'POST',
          body: queryArg.newExtraOptionInBoat,
        }),
        invalidatesTags: ['BoatExtraOptionController'],
      }),
      patchBoatsByIdExtraOptions: build.mutation<
        PatchBoatsByIdExtraOptionsApiResponse,
        PatchBoatsByIdExtraOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/${queryArg.id}/extra-options`,
          method: 'PATCH',
          body: queryArg.extraOptionPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['BoatExtraOptionController'],
      }),
      getBoatsByIdExtraOptions: build.query<
        GetBoatsByIdExtraOptionsApiResponse,
        GetBoatsByIdExtraOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/${queryArg.id}/extra-options`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['BoatExtraOptionController'],
      }),
      deleteBoatsByIdExtraOptions: build.mutation<
        DeleteBoatsByIdExtraOptionsApiResponse,
        DeleteBoatsByIdExtraOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/${queryArg.id}/extra-options`,
          method: 'DELETE',
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['BoatExtraOptionController'],
      }),
      putBoatsById: build.mutation<PutBoatsByIdApiResponse, PutBoatsByIdApiArg>(
        {
          query: (queryArg) => ({
            url: `/boats/${queryArg.id}`,
            method: 'PUT',
            body: queryArg.boat,
          }),
          invalidatesTags: ['BoatController'],
        }
      ),
      patchBoatsById: build.mutation<
        PatchBoatsByIdApiResponse,
        PatchBoatsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.boatPartial,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController'],
      }),
      getBoatsById: build.query<GetBoatsByIdApiResponse, GetBoatsByIdApiArg>({
        query: (queryArg) => ({ url: `/boats/${queryArg.id}` }),
        providesTags: ['BoatController'],
      }),
      deleteBoatsById: build.mutation<
        DeleteBoatsByIdApiResponse,
        DeleteBoatsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/boats/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['BoatController'],
      }),
      postBoats: build.mutation<PostBoatsApiResponse, PostBoatsApiArg>({
        query: (queryArg) => ({
          url: `/boats`,
          method: 'POST',
          body: queryArg.boat,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController'],
      }),
      patchBoats: build.mutation<PatchBoatsApiResponse, PatchBoatsApiArg>({
        query: (queryArg) => ({
          url: `/boats`,
          method: 'PATCH',
          body: queryArg.boatPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['BoatController'],
      }),
      getBoats: build.query<GetBoatsApiResponse, GetBoatsApiArg>({
        query: (queryArg) => ({
          url: `/boats`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            desc: queryArg.desc,
            featured: queryArg.featured,
            category: queryArg.category,
            minLength: queryArg.minLength,
            maxLength: queryArg.maxLength,
            minRate: queryArg.minRate,
            maxRate: queryArg.maxRate,
            currencyCode: queryArg.currencyCode,
            latlng: queryArg.latlng,
            distance: queryArg.distance,
            location: queryArg.location,
            'location.division': queryArg['location.division'],
            port: queryArg.port,
            numberOfPeople: queryArg.numberOfPeople,
            numberOfCabins: queryArg.numberOfCabins,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['BoatController'],
      }),
      getBookableAvailabilityByBookableTypeAndIdSelectedMonthSelectedYear:
        build.query<
          GetBookableAvailabilityByBookableTypeAndIdSelectedMonthSelectedYearApiResponse,
          GetBookableAvailabilityByBookableTypeAndIdSelectedMonthSelectedYearApiArg
        >({
          query: (queryArg) => ({
            url: `/bookable/availability/${queryArg.bookableType}/${queryArg.id}/${queryArg.selectedMonth}/${queryArg.selectedYear}`,
            params: {
              discountCode: queryArg.discountCode,
            },
          }),
          providesTags: [
            'BoatController',
            'ExperienceController',
            'PropertyController',
          ],
        }),
      postBookableDeleteByIdAndBookableType: build.mutation<
        PostBookableDeleteByIdAndBookableTypeApiResponse,
        PostBookableDeleteByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable/delete/${queryArg.id}/${queryArg.bookableType}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookableFeatured: build.query<
        GetBookableFeaturedApiResponse,
        GetBookableFeaturedApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable/featured`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookableGetByIdAndBookableType: build.query<
        GetBookableGetByIdAndBookableTypeApiResponse,
        GetBookableGetByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable/get/${queryArg.id}/${queryArg.bookableType}`,
        }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookableManagedByUserId: build.query<
        GetBookableManagedByUserIdApiResponse,
        GetBookableManagedByUserIdApiArg
      >({
        query: (queryArg) => ({ url: `/bookable/managed/${queryArg.userId}` }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookableRecommendedByIdAndBookableType: build.query<
        GetBookableRecommendedByIdAndBookableTypeApiResponse,
        GetBookableRecommendedByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable/recommended/${queryArg.id}/${queryArg.bookableType}`,
        }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      patchBookableUpdateListingOrder: build.mutation<
        PatchBookableUpdateListingOrderApiResponse,
        PatchBookableUpdateListingOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable/update-listing-order`,
          method: 'PATCH',
          body: queryArg.bookableOrderUpdateRequest,
        }),
        invalidatesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookableReviewsDenyById: build.mutation<
        PostBookableReviewsDenyByIdApiResponse,
        PostBookableReviewsDenyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable-reviews/deny/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['ReviewController'],
      }),
      getBookableReviewsUnverified: build.query<
        GetBookableReviewsUnverifiedApiResponse,
        GetBookableReviewsUnverifiedApiArg
      >({
        query: () => ({ url: `/bookable-reviews/unverified` }),
        providesTags: ['ReviewController'],
      }),
      postBookableReviewsVerifyById: build.mutation<
        PostBookableReviewsVerifyByIdApiResponse,
        PostBookableReviewsVerifyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable-reviews/verify/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['BoatController'],
      }),
      getBookableReviewsByBookableId: build.query<
        GetBookableReviewsByBookableIdApiResponse,
        GetBookableReviewsByBookableIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookable-reviews/${queryArg.bookableId}`,
        }),
        providesTags: ['ReviewController'],
      }),
      postBookingCalculateTotals: build.mutation<
        PostBookingCalculateTotalsApiResponse,
        PostBookingCalculateTotalsApiArg
      >({
        query: (queryArg) => ({
          url: `/booking/calculateTotals`,
          method: 'POST',
          body: queryArg.newBooking,
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsAcceptByBookingId: build.mutation<
        PostBookingsAcceptByBookingIdApiResponse,
        PostBookingsAcceptByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/accept/${queryArg.bookingId}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsAdminBookings: build.query<
        GetBookingsAdminBookingsApiResponse,
        GetBookingsAdminBookingsApiArg
      >({
        query: () => ({ url: `/bookings/admin-bookings` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsCancelByBookingId: build.mutation<
        PostBookingsCancelByBookingIdApiResponse,
        PostBookingsCancelByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/cancel/${queryArg.bookingId}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsCount: build.query<
        GetBookingsCountApiResponse,
        GetBookingsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsExtendOfferByBookingId: build.mutation<
        PostBookingsExtendOfferByBookingIdApiResponse,
        PostBookingsExtendOfferByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/extend-offer/${queryArg.bookingId}`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsManagerBookings: build.query<
        GetBookingsManagerBookingsApiResponse,
        GetBookingsManagerBookingsApiArg
      >({
        query: () => ({ url: `/bookings/manager-bookings` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      patchBookingsMarkAsPaidOutByBookingId: build.mutation<
        PatchBookingsMarkAsPaidOutByBookingIdApiResponse,
        PatchBookingsMarkAsPaidOutByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/markAsPaidOut/${queryArg.bookingId}`,
          method: 'PATCH',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      patchBookingsMarkAsRefundedByBookingId: build.mutation<
        PatchBookingsMarkAsRefundedByBookingIdApiResponse,
        PatchBookingsMarkAsRefundedByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/markAsRefunded/${queryArg.bookingId}`,
          method: 'PATCH',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsMyBookings: build.query<
        GetBookingsMyBookingsApiResponse,
        GetBookingsMyBookingsApiArg
      >({
        query: () => ({ url: `/bookings/my-bookings` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsOffPlatformOffer: build.mutation<
        PostBookingsOffPlatformOfferApiResponse,
        PostBookingsOffPlatformOfferApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/off-platform-offer`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsPayoutsCount: build.query<
        GetBookingsPayoutsCountApiResponse,
        GetBookingsPayoutsCountApiArg
      >({
        query: () => ({ url: `/bookings/payouts/count` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsPayouts: build.query<
        GetBookingsPayoutsApiResponse,
        GetBookingsPayoutsApiArg
      >({
        query: () => ({ url: `/bookings/payouts` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsRefunds: build.query<
        GetBookingsRefundsApiResponse,
        GetBookingsRefundsApiArg
      >({
        query: () => ({ url: `/bookings/refunds` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsRejectByBookingId: build.mutation<
        PostBookingsRejectByBookingIdApiResponse,
        PostBookingsRejectByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/reject/${queryArg.bookingId}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsResendConfirmationByBookingId: build.mutation<
        PostBookingsResendConfirmationByBookingIdApiResponse,
        PostBookingsResendConfirmationByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/resendConfirmation/${queryArg.bookingId}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsRevenueReport: build.query<
        GetBookingsRevenueReportApiResponse,
        GetBookingsRevenueReportApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/revenue-report`,
          params: {
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
            operatorId: queryArg.operatorId,
            bookableType: queryArg.bookableType,
            targetCurrency: queryArg.targetCurrency,
          },
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsRevokeOfferByBookingId: build.mutation<
        PostBookingsRevokeOfferByBookingIdApiResponse,
        PostBookingsRevokeOfferByBookingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/revoke-offer/${queryArg.bookingId}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsStripeIntentById: build.query<
        GetBookingsStripeIntentByIdApiResponse,
        GetBookingsStripeIntentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/stripe-intent/${queryArg.id}`,
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      patchBookingsUpdateBookingStatusById: build.mutation<
        PatchBookingsUpdateBookingStatusByIdApiResponse,
        PatchBookingsUpdateBookingStatusByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/update-booking-status/${queryArg.id}`,
          method: 'PATCH',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsByIdClientSecret: build.query<
        GetBookingsByIdClientSecretApiResponse,
        GetBookingsByIdClientSecretApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}/client-secret`,
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsByIdResendKeyholderEmail: build.mutation<
        PostBookingsByIdResendKeyholderEmailApiResponse,
        PostBookingsByIdResendKeyholderEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}/resendKeyholderEmail`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookingsByIdSetupIntents: build.mutation<
        PostBookingsByIdSetupIntentsApiResponse,
        PostBookingsByIdSetupIntentsApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}/setupIntents`,
          method: 'POST',
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsByIdValidateAvailable: build.query<
        GetBookingsByIdValidateAvailableApiResponse,
        GetBookingsByIdValidateAvailableApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}/validateAvailable`,
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      putBookingsById: build.mutation<
        PutBookingsByIdApiResponse,
        PutBookingsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.booking,
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      patchBookingsById: build.mutation<
        PatchBookingsByIdApiResponse,
        PatchBookingsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updatedBooking,
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsById: build.query<
        GetBookingsByIdApiResponse,
        GetBookingsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/bookings/${queryArg.id}` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      deleteBookingsById: build.mutation<
        DeleteBookingsByIdApiResponse,
        DeleteBookingsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      postBookings: build.mutation<PostBookingsApiResponse, PostBookingsApiArg>(
        {
          query: (queryArg) => ({
            url: `/bookings`,
            method: 'POST',
            body: queryArg.newBooking,
            headers: {
              brand: queryArg.brand,
            },
          }),
          invalidatesTags: [
            'BoatController',
            'BookingController',
            'ExperienceController',
            'PropertyController',
          ],
        }
      ),
      patchBookings: build.mutation<
        PatchBookingsApiResponse,
        PatchBookingsApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings`,
          method: 'PATCH',
          body: queryArg.bookingPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookings: build.query<GetBookingsApiResponse, GetBookingsApiArg>({
        query: (queryArg) => ({
          url: `/bookings`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getBookingsInProgressByBookableId: build.query<
        GetBookingsInProgressByBookableIdApiResponse,
        GetBookingsInProgressByBookableIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bookings-in-progress/${queryArg.bookableId}`,
        }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getCalendarsByIdAndBookableType: build.query<
        GetCalendarsByIdAndBookableTypeApiResponse,
        GetCalendarsByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/calendars/${queryArg.id}/${queryArg.bookableType}`,
        }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getCategoriesCount: build.query<
        GetCategoriesCountApiResponse,
        GetCategoriesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/categories/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['CategoryController'],
      }),
      putCategoriesById: build.mutation<
        PutCategoriesByIdApiResponse,
        PutCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/categories/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.category,
        }),
        invalidatesTags: ['CategoryController'],
      }),
      patchCategoriesById: build.mutation<
        PatchCategoriesByIdApiResponse,
        PatchCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/categories/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.categoryPartial,
        }),
        invalidatesTags: ['CategoryController'],
      }),
      getCategoriesById: build.query<
        GetCategoriesByIdApiResponse,
        GetCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/categories/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['CategoryController'],
      }),
      deleteCategoriesById: build.mutation<
        DeleteCategoriesByIdApiResponse,
        DeleteCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/categories/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['CategoryController'],
      }),
      postCategories: build.mutation<
        PostCategoriesApiResponse,
        PostCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/categories`,
          method: 'POST',
          body: queryArg.newCategory,
        }),
        invalidatesTags: ['CategoryController'],
      }),
      patchCategories: build.mutation<
        PatchCategoriesApiResponse,
        PatchCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/categories`,
          method: 'PATCH',
          body: queryArg.categoryPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['CategoryController'],
      }),
      getCategories: build.query<GetCategoriesApiResponse, GetCategoriesApiArg>(
        {
          query: (queryArg) => ({
            url: `/categories`,
            params: {
              bookableTypes: queryArg.bookableTypes,
            },
          }),
          providesTags: ['CategoryController'],
        }
      ),
      getContentCount: build.query<
        GetContentCountApiResponse,
        GetContentCountApiArg
      >({
        query: (queryArg) => ({
          url: `/content/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['ContentController'],
      }),
      putContentById: build.mutation<
        PutContentByIdApiResponse,
        PutContentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/content/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.content,
        }),
        invalidatesTags: ['ContentController'],
      }),
      patchContentById: build.mutation<
        PatchContentByIdApiResponse,
        PatchContentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/content/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.contentPartial,
        }),
        invalidatesTags: ['ContentController'],
      }),
      getContentById: build.query<
        GetContentByIdApiResponse,
        GetContentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/content/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['ContentController'],
      }),
      deleteContentById: build.mutation<
        DeleteContentByIdApiResponse,
        DeleteContentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/content/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ContentController'],
      }),
      postContent: build.mutation<PostContentApiResponse, PostContentApiArg>({
        query: (queryArg) => ({
          url: `/content`,
          method: 'POST',
          body: queryArg.newContent,
        }),
        invalidatesTags: ['ContentController'],
      }),
      patchContent: build.mutation<PatchContentApiResponse, PatchContentApiArg>(
        {
          query: (queryArg) => ({
            url: `/content`,
            method: 'PATCH',
            body: queryArg.contentPartial,
            params: {
              where: queryArg.where,
            },
          }),
          invalidatesTags: ['ContentController'],
        }
      ),
      getContent: build.query<GetContentApiResponse, GetContentApiArg>({
        query: (queryArg) => ({
          url: `/content`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['ContentController'],
      }),
      getConversationsCount: build.query<
        GetConversationsCountApiResponse,
        GetConversationsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['ConversationController'],
      }),
      putConversationsById: build.mutation<
        PutConversationsByIdApiResponse,
        PutConversationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.conversation,
        }),
        invalidatesTags: ['ConversationController'],
      }),
      patchConversationsById: build.mutation<
        PatchConversationsByIdApiResponse,
        PatchConversationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.conversationPartial,
        }),
        invalidatesTags: ['ConversationController'],
      }),
      getConversationsById: build.query<
        GetConversationsByIdApiResponse,
        GetConversationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['ConversationController'],
      }),
      deleteConversationsById: build.mutation<
        DeleteConversationsByIdApiResponse,
        DeleteConversationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ConversationController'],
      }),
      postConversations: build.mutation<
        PostConversationsApiResponse,
        PostConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations`,
          method: 'POST',
          body: queryArg.newConversation,
        }),
        invalidatesTags: ['ConversationController'],
      }),
      patchConversations: build.mutation<
        PatchConversationsApiResponse,
        PatchConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/conversations`,
          method: 'PATCH',
          body: queryArg.conversationPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['ConversationController'],
      }),
      getCurl: build.query<GetCurlApiResponse, GetCurlApiArg>({
        query: () => ({ url: `/curl` }),
        providesTags: ['CronController'],
      }),
      getExchangeRates: build.query<
        GetExchangeRatesApiResponse,
        GetExchangeRatesApiArg
      >({
        query: () => ({ url: `/exchange-rates` }),
        providesTags: ['ExchangeRateController'],
      }),
      getExperiencesCount: build.query<
        GetExperiencesCountApiResponse,
        GetExperiencesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences/count`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            desc: queryArg.desc,
            featured: queryArg.featured,
            category: queryArg.category,
            minRate: queryArg.minRate,
            maxRate: queryArg.maxRate,
            currencyCode: queryArg.currencyCode,
            latlng: queryArg.latlng,
            distance: queryArg.distance,
            location: queryArg.location,
            'location.division': queryArg['location.division'],
            numberOfPeople: queryArg.numberOfPeople,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['ExperienceController'],
      }),
      postExperiencesDenyById: build.mutation<
        PostExperiencesDenyByIdApiResponse,
        PostExperiencesDenyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences/deny/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      getExperiencesFeatured: build.query<
        GetExperiencesFeaturedApiResponse,
        GetExperiencesFeaturedApiArg
      >({
        query: () => ({ url: `/experiences/featured` }),
        providesTags: ['ExperienceController'],
      }),
      getExperiencesLocations: build.query<
        GetExperiencesLocationsApiResponse,
        GetExperiencesLocationsApiArg
      >({
        query: () => ({ url: `/experiences/locations` }),
        providesTags: ['ExperienceController'],
      }),
      getExperiencesManagerExperiences: build.query<
        GetExperiencesManagerExperiencesApiResponse,
        GetExperiencesManagerExperiencesApiArg
      >({
        query: () => ({ url: `/experiences/manager-experiences` }),
        providesTags: ['ExperienceController'],
      }),
      getExperiencesUnverified: build.query<
        GetExperiencesUnverifiedApiResponse,
        GetExperiencesUnverifiedApiArg
      >({
        query: () => ({ url: `/experiences/unverified` }),
        providesTags: ['ExperienceController'],
      }),
      getExperiencesVerifiedManagerWithBookings: build.query<
        GetExperiencesVerifiedManagerWithBookingsApiResponse,
        GetExperiencesVerifiedManagerWithBookingsApiArg
      >({
        query: () => ({ url: `/experiences/verified-manager-with-bookings` }),
        providesTags: ['ExperienceController'],
      }),
      postExperiencesVerifyById: build.mutation<
        PostExperiencesVerifyByIdApiResponse,
        PostExperiencesVerifyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences/verify/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      putExperiencesById: build.mutation<
        PutExperiencesByIdApiResponse,
        PutExperiencesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.experience,
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      patchExperiencesById: build.mutation<
        PatchExperiencesByIdApiResponse,
        PatchExperiencesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.experiencePartial,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      getExperiencesById: build.query<
        GetExperiencesByIdApiResponse,
        GetExperiencesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/experiences/${queryArg.id}` }),
        providesTags: ['ExperienceController'],
      }),
      deleteExperiencesById: build.mutation<
        DeleteExperiencesByIdApiResponse,
        DeleteExperiencesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      postExperiences: build.mutation<
        PostExperiencesApiResponse,
        PostExperiencesApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences`,
          method: 'POST',
          body: queryArg.experience,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      patchExperiences: build.mutation<
        PatchExperiencesApiResponse,
        PatchExperiencesApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences`,
          method: 'PATCH',
          body: queryArg.experiencePartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['ExperienceController'],
      }),
      getExperiences: build.query<
        GetExperiencesApiResponse,
        GetExperiencesApiArg
      >({
        query: (queryArg) => ({
          url: `/experiences`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            desc: queryArg.desc,
            featured: queryArg.featured,
            category: queryArg.category,
            minRate: queryArg.minRate,
            maxRate: queryArg.maxRate,
            currencyCode: queryArg.currencyCode,
            latlng: queryArg.latlng,
            distance: queryArg.distance,
            location: queryArg.location,
            'location.division': queryArg['location.division'],
            numberOfPeople: queryArg.numberOfPeople,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['ExperienceController'],
      }),
      getExtraOptionCategories: build.query<
        GetExtraOptionCategoriesApiResponse,
        GetExtraOptionCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/extra-option-categories`,
          params: {
            bookableTypes: queryArg.bookableTypes,
          },
        }),
        providesTags: ['ExtraOptionTypeExtraOptionCategoryController'],
      }),
      getExtraOptionTypesByIdExtraOptionCategory: build.query<
        GetExtraOptionTypesByIdExtraOptionCategoryApiResponse,
        GetExtraOptionTypesByIdExtraOptionCategoryApiArg
      >({
        query: (queryArg) => ({
          url: `/extra-option-types/${queryArg.id}/extra-option-category`,
        }),
        providesTags: ['ExtraOptionTypeExtraOptionCategoryController'],
      }),
      getExtraOptionTypes: build.query<
        GetExtraOptionTypesApiResponse,
        GetExtraOptionTypesApiArg
      >({
        query: () => ({ url: `/extra-option-types` }),
        providesTags: ['ExtraOptionTypeExtraOptionCategoryController'],
      }),
      getFaqs: build.query<GetFaqsApiResponse, GetFaqsApiArg>({
        query: () => ({ url: `/faqs` }),
        providesTags: ['FaqController'],
      }),
      getFeedsBookablesGoogleAdsTsv: build.query<
        GetFeedsBookablesGoogleAdsTsvApiResponse,
        GetFeedsBookablesGoogleAdsTsvApiArg
      >({
        query: () => ({ url: `/feeds/bookables-google-ads.tsv` }),
        providesTags: ['FeedController'],
      }),
      getFeedsBookablesTsv: build.query<
        GetFeedsBookablesTsvApiResponse,
        GetFeedsBookablesTsvApiArg
      >({
        query: () => ({ url: `/feeds/bookables.tsv` }),
        providesTags: ['FeedController'],
      }),
      getHasReviewedByBookingId: build.query<
        GetHasReviewedByBookingIdApiResponse,
        GetHasReviewedByBookingIdApiArg
      >({
        query: (queryArg) => ({ url: `/has-reviewed/${queryArg.bookingId}` }),
        providesTags: ['ReviewController'],
      }),
      getIsUserByEmail: build.query<
        GetIsUserByEmailApiResponse,
        GetIsUserByEmailApiArg
      >({
        query: (queryArg) => ({ url: `/isUser/${queryArg.email}` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      getLocationsCount: build.query<
        GetLocationsCountApiResponse,
        GetLocationsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['LocationController'],
      }),
      putLocationsById: build.mutation<
        PutLocationsByIdApiResponse,
        PutLocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.location,
        }),
        invalidatesTags: ['LocationController'],
      }),
      patchLocationsById: build.mutation<
        PatchLocationsByIdApiResponse,
        PatchLocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.locationPartial,
        }),
        invalidatesTags: ['LocationController'],
      }),
      getLocationsById: build.query<
        GetLocationsByIdApiResponse,
        GetLocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['LocationController'],
      }),
      deleteLocationsById: build.mutation<
        DeleteLocationsByIdApiResponse,
        DeleteLocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['LocationController'],
      }),
      postLocations: build.mutation<
        PostLocationsApiResponse,
        PostLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/locations`,
          method: 'POST',
          body: queryArg.newLocation,
        }),
        invalidatesTags: ['LocationController'],
      }),
      patchLocations: build.mutation<
        PatchLocationsApiResponse,
        PatchLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/locations`,
          method: 'PATCH',
          body: queryArg.locationPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['LocationController'],
      }),
      getLocations: build.query<GetLocationsApiResponse, GetLocationsApiArg>({
        query: (queryArg) => ({
          url: `/locations`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['LocationController'],
      }),
      deleteMediaCloudflareDeleteById: build.mutation<
        DeleteMediaCloudflareDeleteByIdApiResponse,
        DeleteMediaCloudflareDeleteByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/media/cloudflare/delete/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['MediaController'],
      }),
      getMediaCloudflareUpload: build.query<
        GetMediaCloudflareUploadApiResponse,
        GetMediaCloudflareUploadApiArg
      >({
        query: () => ({ url: `/media/cloudflare/upload` }),
        providesTags: ['MediaController'],
      }),
      getMediaUploadUrlByStageAndFilenameFilesize: build.query<
        GetMediaUploadUrlByStageAndFilenameFilesizeApiResponse,
        GetMediaUploadUrlByStageAndFilenameFilesizeApiArg
      >({
        query: (queryArg) => ({
          url: `/media/upload-url/${queryArg.stage}/${queryArg.filename}/${queryArg.filesize}`,
        }),
        providesTags: ['MediaController'],
      }),
      deleteMediaByIdAndStage: build.mutation<
        DeleteMediaByIdAndStageApiResponse,
        DeleteMediaByIdAndStageApiArg
      >({
        query: (queryArg) => ({
          url: `/media/${queryArg.id}/${queryArg.stage}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['MediaController'],
      }),
      postMedia: build.mutation<PostMediaApiResponse, PostMediaApiArg>({
        query: (queryArg) => ({
          url: `/media`,
          method: 'POST',
          body: queryArg.media,
        }),
        invalidatesTags: ['MediaController'],
      }),
      getMessagesCount: build.query<
        GetMessagesCountApiResponse,
        GetMessagesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['MessageController'],
      }),
      getMessagesByIdOriginal: build.query<
        GetMessagesByIdOriginalApiResponse,
        GetMessagesByIdOriginalApiArg
      >({
        query: (queryArg) => ({ url: `/messages/${queryArg.id}/original` }),
        providesTags: ['MessageController'],
      }),
      patchMessagesByIdReadReceipt: build.mutation<
        PatchMessagesByIdReadReceiptApiResponse,
        PatchMessagesByIdReadReceiptApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}/read-receipt`,
          method: 'PATCH',
        }),
        invalidatesTags: ['MessageController'],
      }),
      postMessagesByIdReapplyModeration: build.mutation<
        PostMessagesByIdReapplyModerationApiResponse,
        PostMessagesByIdReapplyModerationApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}/reapply-moderation`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['MessageController'],
      }),
      postMessagesByIdRestoreOriginal: build.mutation<
        PostMessagesByIdRestoreOriginalApiResponse,
        PostMessagesByIdRestoreOriginalApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}/restore-original`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['MessageController'],
      }),
      putMessagesById: build.mutation<
        PutMessagesByIdApiResponse,
        PutMessagesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.message,
        }),
        invalidatesTags: ['MessageController'],
      }),
      patchMessagesById: build.mutation<
        PatchMessagesByIdApiResponse,
        PatchMessagesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.messagePartial,
        }),
        invalidatesTags: ['MessageController'],
      }),
      getMessagesById: build.query<
        GetMessagesByIdApiResponse,
        GetMessagesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['MessageController'],
      }),
      deleteMessagesById: build.mutation<
        DeleteMessagesByIdApiResponse,
        DeleteMessagesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['MessageController'],
      }),
      postMessages: build.mutation<PostMessagesApiResponse, PostMessagesApiArg>(
        {
          query: (queryArg) => ({
            url: `/messages`,
            method: 'POST',
            body: queryArg.newMessage,
          }),
          invalidatesTags: ['MessageController'],
        }
      ),
      patchMessages: build.mutation<
        PatchMessagesApiResponse,
        PatchMessagesApiArg
      >({
        query: (queryArg) => ({
          url: `/messages`,
          method: 'PATCH',
          body: queryArg.messagePartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['MessageController'],
      }),
      getMessages: build.query<GetMessagesApiResponse, GetMessagesApiArg>({
        query: (queryArg) => ({
          url: `/messages`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['MessageController'],
      }),
      getOauthUrlByIdAndBookableType: build.query<
        GetOauthUrlByIdAndBookableTypeApiResponse,
        GetOauthUrlByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/oauth-url/${queryArg.id}/${queryArg.bookableType}`,
        }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getOffersByToken: build.query<
        GetOffersByTokenApiResponse,
        GetOffersByTokenApiArg
      >({
        query: (queryArg) => ({ url: `/offers/${queryArg.token}` }),
        providesTags: [
          'BoatController',
          'BookingController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getPasswordResetIsResetLinkValidByResetId: build.query<
        GetPasswordResetIsResetLinkValidByResetIdApiResponse,
        GetPasswordResetIsResetLinkValidByResetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/is-reset-link-valid/${queryArg.resetId}`,
        }),
        providesTags: ['PasswordResetRequestController'],
      }),
      postPasswordResetRequestByUserEmail: build.mutation<
        PostPasswordResetRequestByUserEmailApiResponse,
        PostPasswordResetRequestByUserEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/request/${queryArg.userEmail}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['PasswordResetRequestController'],
      }),
      postPasswordResetResetPassword: build.mutation<
        PostPasswordResetResetPasswordApiResponse,
        PostPasswordResetResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/reset-password`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['PasswordResetRequestController'],
      }),
      patchPayoutDetailsById: build.mutation<
        PatchPayoutDetailsByIdApiResponse,
        PatchPayoutDetailsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/payout-details/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.payoutDetails,
        }),
        invalidatesTags: ['PayoutDetailsController'],
      }),
      getPayoutDetailsByUserId: build.query<
        GetPayoutDetailsByUserIdApiResponse,
        GetPayoutDetailsByUserIdApiArg
      >({
        query: (queryArg) => ({ url: `/payout-details/${queryArg.userId}` }),
        providesTags: ['PayoutDetailsController'],
      }),
      postPayoutDetails: build.mutation<
        PostPayoutDetailsApiResponse,
        PostPayoutDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/payout-details`,
          method: 'POST',
          body: queryArg.payoutDetails,
        }),
        invalidatesTags: ['PayoutDetailsController'],
      }),
      getPayoutDetails: build.query<
        GetPayoutDetailsApiResponse,
        GetPayoutDetailsApiArg
      >({
        query: () => ({ url: `/payout-details` }),
        providesTags: ['PayoutDetailsController'],
      }),
      getPing: build.query<GetPingApiResponse, GetPingApiArg>({
        query: () => ({ url: `/ping` }),
        providesTags: ['PingController'],
      }),
      getPortsCount: build.query<GetPortsCountApiResponse, GetPortsCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/ports/count`,
            params: {
              where: queryArg.where,
            },
          }),
          providesTags: ['PortController'],
        }
      ),
      putPortsById: build.mutation<PutPortsByIdApiResponse, PutPortsByIdApiArg>(
        {
          query: (queryArg) => ({
            url: `/ports/${queryArg.id}`,
            method: 'PUT',
            body: queryArg.port,
          }),
          invalidatesTags: ['PortController'],
        }
      ),
      patchPortsById: build.mutation<
        PatchPortsByIdApiResponse,
        PatchPortsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ports/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.portPartial,
        }),
        invalidatesTags: ['PortController'],
      }),
      getPortsById: build.query<GetPortsByIdApiResponse, GetPortsByIdApiArg>({
        query: (queryArg) => ({
          url: `/ports/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['PortController'],
      }),
      deletePortsById: build.mutation<
        DeletePortsByIdApiResponse,
        DeletePortsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ports/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['PortController'],
      }),
      postPorts: build.mutation<PostPortsApiResponse, PostPortsApiArg>({
        query: (queryArg) => ({
          url: `/ports`,
          method: 'POST',
          body: queryArg.newPort,
        }),
        invalidatesTags: ['PortController'],
      }),
      patchPorts: build.mutation<PatchPortsApiResponse, PatchPortsApiArg>({
        query: (queryArg) => ({
          url: `/ports`,
          method: 'PATCH',
          body: queryArg.portPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['PortController'],
      }),
      getPorts: build.query<GetPortsApiResponse, GetPortsApiArg>({
        query: (queryArg) => ({
          url: `/ports`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['PortController'],
      }),
      getPropertiesCount: build.query<
        GetPropertiesCountApiResponse,
        GetPropertiesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/properties/count`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            desc: queryArg.desc,
            featured: queryArg.featured,
            category: queryArg.category,
            minRate: queryArg.minRate,
            maxRate: queryArg.maxRate,
            currencyCode: queryArg.currencyCode,
            latlng: queryArg.latlng,
            distance: queryArg.distance,
            location: queryArg.location,
            'location.division': queryArg['location.division'],
            numberOfPeople: queryArg.numberOfPeople,
            numberOfRooms: queryArg.numberOfRooms,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['PropertyController'],
      }),
      postPropertiesDenyById: build.mutation<
        PostPropertiesDenyByIdApiResponse,
        PostPropertiesDenyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/properties/deny/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['PropertyController'],
      }),
      getPropertiesLocations: build.query<
        GetPropertiesLocationsApiResponse,
        GetPropertiesLocationsApiArg
      >({
        query: () => ({ url: `/properties/locations` }),
        providesTags: ['PropertyController'],
      }),
      getPropertiesManagerProperties: build.query<
        GetPropertiesManagerPropertiesApiResponse,
        GetPropertiesManagerPropertiesApiArg
      >({
        query: () => ({ url: `/properties/manager-properties` }),
        providesTags: ['PropertyController'],
      }),
      getPropertiesUnverified: build.query<
        GetPropertiesUnverifiedApiResponse,
        GetPropertiesUnverifiedApiArg
      >({
        query: () => ({ url: `/properties/unverified` }),
        providesTags: ['PropertyController'],
      }),
      getPropertiesVerifiedManagerWithBookings: build.query<
        GetPropertiesVerifiedManagerWithBookingsApiResponse,
        GetPropertiesVerifiedManagerWithBookingsApiArg
      >({
        query: () => ({ url: `/properties/verified-manager-with-bookings` }),
        providesTags: ['PropertyController'],
      }),
      postPropertiesVerifyById: build.mutation<
        PostPropertiesVerifyByIdApiResponse,
        PostPropertiesVerifyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/properties/verify/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['PropertyController'],
      }),
      putPropertiesById: build.mutation<
        PutPropertiesByIdApiResponse,
        PutPropertiesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/properties/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.property,
        }),
        invalidatesTags: ['PropertyController'],
      }),
      patchPropertiesById: build.mutation<
        PatchPropertiesByIdApiResponse,
        PatchPropertiesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/properties/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.propertyPartial,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['PropertyController'],
      }),
      getPropertiesById: build.query<
        GetPropertiesByIdApiResponse,
        GetPropertiesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/properties/${queryArg.id}` }),
        providesTags: ['PropertyController'],
      }),
      deletePropertiesById: build.mutation<
        DeletePropertiesByIdApiResponse,
        DeletePropertiesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/properties/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['PropertyController'],
      }),
      postProperties: build.mutation<
        PostPropertiesApiResponse,
        PostPropertiesApiArg
      >({
        query: (queryArg) => ({
          url: `/properties`,
          method: 'POST',
          body: queryArg.property,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['PropertyController'],
      }),
      patchProperties: build.mutation<
        PatchPropertiesApiResponse,
        PatchPropertiesApiArg
      >({
        query: (queryArg) => ({
          url: `/properties`,
          method: 'PATCH',
          body: queryArg.propertyPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['PropertyController'],
      }),
      getProperties: build.query<GetPropertiesApiResponse, GetPropertiesApiArg>(
        {
          query: (queryArg) => ({
            url: `/properties`,
            params: {
              limit: queryArg.limit,
              offset: queryArg.offset,
              order: queryArg.order,
              desc: queryArg.desc,
              featured: queryArg.featured,
              category: queryArg.category,
              minRate: queryArg.minRate,
              maxRate: queryArg.maxRate,
              currencyCode: queryArg.currencyCode,
              latlng: queryArg.latlng,
              distance: queryArg.distance,
              location: queryArg.location,
              'location.division': queryArg['location.division'],
              numberOfPeople: queryArg.numberOfPeople,
              numberOfRooms: queryArg.numberOfRooms,
              startDate: queryArg.startDate,
              endDate: queryArg.endDate,
            },
          }),
          providesTags: ['PropertyController'],
        }
      ),
      postRemoveCalendarByIdAndBookableType: build.mutation<
        PostRemoveCalendarByIdAndBookableTypeApiResponse,
        PostRemoveCalendarByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/remove-calendar/${queryArg.id}/${queryArg.bookableType}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getRoutesCount: build.query<
        GetRoutesCountApiResponse,
        GetRoutesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['RouteController'],
      }),
      putRoutesById: build.mutation<
        PutRoutesByIdApiResponse,
        PutRoutesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.route,
        }),
        invalidatesTags: ['RouteController'],
      }),
      patchRoutesById: build.mutation<
        PatchRoutesByIdApiResponse,
        PatchRoutesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.routePartial,
        }),
        invalidatesTags: ['RouteController'],
      }),
      getRoutesById: build.query<GetRoutesByIdApiResponse, GetRoutesByIdApiArg>(
        {
          query: (queryArg) => ({
            url: `/routes/${queryArg.id}`,
            params: {
              filter: queryArg.filter,
            },
          }),
          providesTags: ['RouteController'],
        }
      ),
      deleteRoutesById: build.mutation<
        DeleteRoutesByIdApiResponse,
        DeleteRoutesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['RouteController'],
      }),
      postRoutes: build.mutation<PostRoutesApiResponse, PostRoutesApiArg>({
        query: (queryArg) => ({
          url: `/routes`,
          method: 'POST',
          body: queryArg.newRoute,
        }),
        invalidatesTags: ['RouteController'],
      }),
      patchRoutes: build.mutation<PatchRoutesApiResponse, PatchRoutesApiArg>({
        query: (queryArg) => ({
          url: `/routes`,
          method: 'PATCH',
          body: queryArg.routePartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['RouteController'],
      }),
      getRoutes: build.query<GetRoutesApiResponse, GetRoutesApiArg>({
        query: (queryArg) => ({
          url: `/routes`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['RouteController'],
      }),
      getSentEmailsCount: build.query<
        GetSentEmailsCountApiResponse,
        GetSentEmailsCountApiArg
      >({
        query: () => ({ url: `/sent-emails/count` }),
        providesTags: ['EmailLogController'],
      }),
      getSentEmails: build.query<GetSentEmailsApiResponse, GetSentEmailsApiArg>(
        {
          query: (queryArg) => ({
            url: `/sent-emails`,
            params: {
              limit: queryArg.limit,
              offset: queryArg.offset,
            },
          }),
          providesTags: ['EmailLogController'],
        }
      ),
      postSetCalendarAuthByIdAndBookableTypeCode: build.mutation<
        PostSetCalendarAuthByIdAndBookableTypeCodeApiResponse,
        PostSetCalendarAuthByIdAndBookableTypeCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/set-calendar-auth/${queryArg.id}/${queryArg.bookableType}/${queryArg.code}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getSitemapBookables: build.query<
        GetSitemapBookablesApiResponse,
        GetSitemapBookablesApiArg
      >({
        query: () => ({ url: `/sitemap/bookables` }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getSkippersCount: build.query<
        GetSkippersCountApiResponse,
        GetSkippersCountApiArg
      >({
        query: (queryArg) => ({
          url: `/skippers/count`,
          params: {
            where: queryArg.where,
          },
        }),
        providesTags: ['SkipperController'],
      }),
      putSkippersById: build.mutation<
        PutSkippersByIdApiResponse,
        PutSkippersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/skippers/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.skipper,
        }),
        invalidatesTags: ['SkipperController'],
      }),
      patchSkippersById: build.mutation<
        PatchSkippersByIdApiResponse,
        PatchSkippersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/skippers/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.skipperPartial,
        }),
        invalidatesTags: ['SkipperController'],
      }),
      getSkippersById: build.query<
        GetSkippersByIdApiResponse,
        GetSkippersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/skippers/${queryArg.id}`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['SkipperController'],
      }),
      deleteSkippersById: build.mutation<
        DeleteSkippersByIdApiResponse,
        DeleteSkippersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/skippers/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['SkipperController'],
      }),
      postSkippers: build.mutation<PostSkippersApiResponse, PostSkippersApiArg>(
        {
          query: (queryArg) => ({
            url: `/skippers`,
            method: 'POST',
            body: queryArg.newSkipper,
          }),
          invalidatesTags: ['SkipperController'],
        }
      ),
      patchSkippers: build.mutation<
        PatchSkippersApiResponse,
        PatchSkippersApiArg
      >({
        query: (queryArg) => ({
          url: `/skippers`,
          method: 'PATCH',
          body: queryArg.skipperPartial,
          params: {
            where: queryArg.where,
          },
        }),
        invalidatesTags: ['SkipperController'],
      }),
      getSkippers: build.query<GetSkippersApiResponse, GetSkippersApiArg>({
        query: (queryArg) => ({
          url: `/skippers`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ['SkipperController'],
      }),
      postStripeConnectAccountLoginLink: build.mutation<
        PostStripeConnectAccountLoginLinkApiResponse,
        PostStripeConnectAccountLoginLinkApiArg
      >({
        query: () => ({
          url: `/stripe-connect/account/login-link`,
          method: 'POST',
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      postStripeConnectAccountSync: build.mutation<
        PostStripeConnectAccountSyncApiResponse,
        PostStripeConnectAccountSyncApiArg
      >({
        query: () => ({ url: `/stripe-connect/account/sync`, method: 'POST' }),
        invalidatesTags: ['StripeConnectController'],
      }),
      postStripeConnectAccount: build.mutation<
        PostStripeConnectAccountApiResponse,
        PostStripeConnectAccountApiArg
      >({
        query: () => ({ url: `/stripe-connect/account`, method: 'POST' }),
        invalidatesTags: ['StripeConnectController'],
      }),
      getStripeConnectAccount: build.query<
        GetStripeConnectAccountApiResponse,
        GetStripeConnectAccountApiArg
      >({
        query: () => ({ url: `/stripe-connect/account` }),
        providesTags: ['StripeConnectController'],
      }),
      getStripeConnectAccountsByIdBookables: build.query<
        GetStripeConnectAccountsByIdBookablesApiResponse,
        GetStripeConnectAccountsByIdBookablesApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/accounts/${queryArg.id}/bookables`,
        }),
        providesTags: ['StripeConnectController'],
      }),
      postStripeConnectAccountsByIdDisable: build.mutation<
        PostStripeConnectAccountsByIdDisableApiResponse,
        PostStripeConnectAccountsByIdDisableApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/accounts/${queryArg.id}/disable`,
          method: 'POST',
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      patchStripeConnectAccountsByIdRouting: build.mutation<
        PatchStripeConnectAccountsByIdRoutingApiResponse,
        PatchStripeConnectAccountsByIdRoutingApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/accounts/${queryArg.id}/routing`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      postStripeConnectAccountsByIdSync: build.mutation<
        PostStripeConnectAccountsByIdSyncApiResponse,
        PostStripeConnectAccountsByIdSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/accounts/${queryArg.id}/sync`,
          method: 'POST',
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      postStripeConnectAccounts: build.mutation<
        PostStripeConnectAccountsApiResponse,
        PostStripeConnectAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/accounts`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      getStripeConnectAccounts: build.query<
        GetStripeConnectAccountsApiResponse,
        GetStripeConnectAccountsApiArg
      >({
        query: () => ({ url: `/stripe-connect/accounts` }),
        providesTags: ['StripeConnectController'],
      }),
      getStripeConnectBookingsByIdCharges: build.query<
        GetStripeConnectBookingsByIdChargesApiResponse,
        GetStripeConnectBookingsByIdChargesApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/bookings/${queryArg.id}/charges`,
        }),
        providesTags: ['StripeConnectController'],
      }),
      postStripeConnectBookingsByIdRefund: build.mutation<
        PostStripeConnectBookingsByIdRefundApiResponse,
        PostStripeConnectBookingsByIdRefundApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/bookings/${queryArg.id}/refund`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      postStripeConnectBookingsByIdReleasePayout: build.mutation<
        PostStripeConnectBookingsByIdReleasePayoutApiResponse,
        PostStripeConnectBookingsByIdReleasePayoutApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/bookings/${queryArg.id}/release-payout`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['StripeConnectController'],
      }),
      getStripeConnectUsersSearch: build.query<
        GetStripeConnectUsersSearchApiResponse,
        GetStripeConnectUsersSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect/users/search`,
          params: {
            q: queryArg.q,
          },
        }),
        providesTags: ['StripeConnectController'],
      }),
      postStripeConnectWebhook: build.mutation<
        PostStripeConnectWebhookApiResponse,
        PostStripeConnectWebhookApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-connect-webhook`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['StripeWebhookController'],
      }),
      postStripeWebhook: build.mutation<
        PostStripeWebhookApiResponse,
        PostStripeWebhookApiArg
      >({
        query: (queryArg) => ({
          url: `/stripe-webhook`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['StripeWebhookController'],
      }),
      postSubmitReview: build.mutation<
        PostSubmitReviewApiResponse,
        PostSubmitReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/submit-review`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['ReviewController'],
      }),
      postSyncCalendarByIdAndBookableType: build.mutation<
        PostSyncCalendarByIdAndBookableTypeApiResponse,
        PostSyncCalendarByIdAndBookableTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/sync-calendar/${queryArg.id}/${queryArg.bookableType}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
      getTrackEmailOpenByEmailLogId: build.query<
        GetTrackEmailOpenByEmailLogIdApiResponse,
        GetTrackEmailOpenByEmailLogIdApiArg
      >({
        query: (queryArg) => ({
          url: `/track-email-open/${queryArg.emailLogId}`,
        }),
        providesTags: ['EmailLogController'],
      }),
      postUserReviewsDenyById: build.mutation<
        PostUserReviewsDenyByIdApiResponse,
        PostUserReviewsDenyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/user-reviews/deny/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['ReviewController'],
      }),
      getUserReviewsUnverified: build.query<
        GetUserReviewsUnverifiedApiResponse,
        GetUserReviewsUnverifiedApiArg
      >({
        query: () => ({ url: `/user-reviews/unverified` }),
        providesTags: ['ReviewController'],
      }),
      postUserReviewsVerifyById: build.mutation<
        PostUserReviewsVerifyByIdApiResponse,
        PostUserReviewsVerifyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/user-reviews/verify/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['UserController'],
      }),
      getUsersBookableId: build.query<
        GetUsersBookableIdApiResponse,
        GetUsersBookableIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/bookableId`,
          params: {
            bookableId: queryArg.bookableId,
            bookableType: queryArg.bookableType,
          },
        }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      postUsersConfirmEmail: build.mutation<
        PostUsersConfirmEmailApiResponse,
        PostUsersConfirmEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/users/confirm-email`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getUsersCount: build.query<GetUsersCountApiResponse, GetUsersCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/users/count`,
            params: {
              where: queryArg.where,
            },
          }),
          providesTags: ['BoatController', 'BookingController'],
        }
      ),
      postUsersDenyByUserId: build.mutation<
        PostUsersDenyByUserIdApiResponse,
        PostUsersDenyByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/deny/${queryArg.userId}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getUsersInfoByUserId: build.query<
        GetUsersInfoByUserIdApiResponse,
        GetUsersInfoByUserIdApiArg
      >({
        query: (queryArg) => ({ url: `/users/info/${queryArg.userId}` }),
        providesTags: ['BoatController', 'BookingController', 'UserController'],
      }),
      postUsersLogin: build.mutation<
        PostUsersLoginApiResponse,
        PostUsersLoginApiArg
      >({
        query: (queryArg) => ({
          url: `/users/login`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      postUsersLogout: build.mutation<
        PostUsersLogoutApiResponse,
        PostUsersLogoutApiArg
      >({
        query: () => ({ url: `/users/logout`, method: 'POST' }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      postUsersMeConsent: build.mutation<
        PostUsersMeConsentApiResponse,
        PostUsersMeConsentApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/consent`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['UserConsentController'],
      }),
      getUsersMeConsent: build.query<
        GetUsersMeConsentApiResponse,
        GetUsersMeConsentApiArg
      >({
        query: () => ({ url: `/users/me/consent` }),
        providesTags: ['UserConsentController'],
      }),
      getUsersMe: build.query<GetUsersMeApiResponse, GetUsersMeApiArg>({
        query: () => ({ url: `/users/me` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      postUsersRequestOwnerAuthorisation: build.mutation<
        PostUsersRequestOwnerAuthorisationApiResponse,
        PostUsersRequestOwnerAuthorisationApiArg
      >({
        query: (queryArg) => ({
          url: `/users/request-owner-authorisation`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      postUsersResendConfirmEmail: build.mutation<
        PostUsersResendConfirmEmailApiResponse,
        PostUsersResendConfirmEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/users/resend-confirm-email`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      postUsersResetPassword: build.mutation<
        PostUsersResetPasswordApiResponse,
        PostUsersResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/users/reset-password`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getUsersSearchBySearch: build.query<
        GetUsersSearchBySearchApiResponse,
        GetUsersSearchBySearchApiArg
      >({
        query: (queryArg) => ({ url: `/users/search/${queryArg.search}` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      getUsersUnverified: build.query<
        GetUsersUnverifiedApiResponse,
        GetUsersUnverifiedApiArg
      >({
        query: () => ({ url: `/users/unverified` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      postUsersUpdateProfilePicture: build.mutation<
        PostUsersUpdateProfilePictureApiResponse,
        PostUsersUpdateProfilePictureApiArg
      >({
        query: (queryArg) => ({
          url: `/users/update-profile-picture`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      postUsersUpdateUserInfo: build.mutation<
        PostUsersUpdateUserInfoApiResponse,
        PostUsersUpdateUserInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/users/update-user-info`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getUsersUserPrivateReviews: build.query<
        GetUsersUserPrivateReviewsApiResponse,
        GetUsersUserPrivateReviewsApiArg
      >({
        query: () => ({ url: `/users/user-private-reviews` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      getUsersUserReviewsByUserId: build.query<
        GetUsersUserReviewsByUserIdApiResponse,
        GetUsersUserReviewsByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/user-reviews/${queryArg.userId}`,
        }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      postUsersVerifyByUserId: build.mutation<
        PostUsersVerifyByUserIdApiResponse,
        PostUsersVerifyByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/verify/${queryArg.userId}`,
          method: 'POST',
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getUsersByUserIdConversations: build.query<
        GetUsersByUserIdConversationsApiResponse,
        GetUsersByUserIdConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/${queryArg.userId}/conversations`,
          params: {
            archived: queryArg.archived,
            sort: queryArg.sort,
            limit: queryArg.limit,
            skip: queryArg.skip,
            lastMessageFrom: queryArg.lastMessageFrom,
            lastMessageTo: queryArg.lastMessageTo,
            keywords: queryArg.keywords,
            includeDeleted: queryArg.includeDeleted,
            messagesSampleSize: queryArg.messagesSampleSize,
            messagesReturnCount: queryArg.messagesReturnCount,
          },
        }),
        providesTags: ['ConversationController'],
      }),
      putUsersByUserId: build.mutation<
        PutUsersByUserIdApiResponse,
        PutUsersByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/${queryArg.userId}`,
          method: 'PUT',
          body: queryArg.user,
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getUsersByUserId: build.query<
        GetUsersByUserIdApiResponse,
        GetUsersByUserIdApiArg
      >({
        query: (queryArg) => ({ url: `/users/${queryArg.userId}` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      postUsers: build.mutation<PostUsersApiResponse, PostUsersApiArg>({
        query: (queryArg) => ({
          url: `/users`,
          method: 'POST',
          body: queryArg.userWithPassword,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['BoatController', 'BookingController'],
      }),
      getVehiclesCount: build.query<
        GetVehiclesCountApiResponse,
        GetVehiclesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/count`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            desc: queryArg.desc,
            featured: queryArg.featured,
            category: queryArg.category,
            minRate: queryArg.minRate,
            maxRate: queryArg.maxRate,
            currencyCode: queryArg.currencyCode,
            latlng: queryArg.latlng,
            distance: queryArg.distance,
            location: queryArg.location,
            'location.division': queryArg['location.division'],
            numberOfPeople: queryArg.numberOfPeople,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['VehicleController'],
      }),
      getVehiclesLocations: build.query<
        GetVehiclesLocationsApiResponse,
        GetVehiclesLocationsApiArg
      >({
        query: () => ({ url: `/vehicles/locations` }),
        providesTags: ['VehicleController'],
      }),
      getVehiclesManagerVehicles: build.query<
        GetVehiclesManagerVehiclesApiResponse,
        GetVehiclesManagerVehiclesApiArg
      >({
        query: () => ({ url: `/vehicles/manager-vehicles` }),
        providesTags: ['VehicleController'],
      }),
      postVehiclesRejectById: build.mutation<
        PostVehiclesRejectByIdApiResponse,
        PostVehiclesRejectByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/reject/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['VehicleController'],
      }),
      getVehiclesUnverified: build.query<
        GetVehiclesUnverifiedApiResponse,
        GetVehiclesUnverifiedApiArg
      >({
        query: () => ({ url: `/vehicles/unverified` }),
        providesTags: ['VehicleController'],
      }),
      getVehiclesVerifiedManagerWithBookings: build.query<
        GetVehiclesVerifiedManagerWithBookingsApiResponse,
        GetVehiclesVerifiedManagerWithBookingsApiArg
      >({
        query: () => ({ url: `/vehicles/verified-manager-with-bookings` }),
        providesTags: ['VehicleController'],
      }),
      postVehiclesVerifyById: build.mutation<
        PostVehiclesVerifyByIdApiResponse,
        PostVehiclesVerifyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/verify/${queryArg.id}`,
          method: 'POST',
        }),
        invalidatesTags: ['VehicleController'],
      }),
      putVehiclesById: build.mutation<
        PutVehiclesByIdApiResponse,
        PutVehiclesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.vehicle,
        }),
        invalidatesTags: ['VehicleController'],
      }),
      patchVehiclesById: build.mutation<
        PatchVehiclesByIdApiResponse,
        PatchVehiclesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.vehiclePartial,
          headers: {
            brand: queryArg.brand,
          },
        }),
        invalidatesTags: ['VehicleController'],
      }),
      getVehiclesById: build.query<
        GetVehiclesByIdApiResponse,
        GetVehiclesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/vehicles/${queryArg.id}` }),
        providesTags: ['VehicleController'],
      }),
      deleteVehiclesById: build.mutation<
        DeleteVehiclesByIdApiResponse,
        DeleteVehiclesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['VehicleController'],
      }),
      postVehicles: build.mutation<PostVehiclesApiResponse, PostVehiclesApiArg>(
        {
          query: (queryArg) => ({
            url: `/vehicles`,
            method: 'POST',
            body: queryArg.newVehicle,
            headers: {
              brand: queryArg.brand,
            },
          }),
          invalidatesTags: ['VehicleController'],
        }
      ),
      getVehicles: build.query<GetVehiclesApiResponse, GetVehiclesApiArg>({
        query: (queryArg) => ({
          url: `/vehicles`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            desc: queryArg.desc,
            featured: queryArg.featured,
            category: queryArg.category,
            minRate: queryArg.minRate,
            maxRate: queryArg.maxRate,
            currencyCode: queryArg.currencyCode,
            latlng: queryArg.latlng,
            distance: queryArg.distance,
            location: queryArg.location,
            'location.division': queryArg['location.division'],
            numberOfPeople: queryArg.numberOfPeople,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['VehicleController'],
      }),
      getWhoAmI: build.query<GetWhoAmIApiResponse, GetWhoAmIApiArg>({
        query: () => ({ url: `/whoAmI` }),
        providesTags: ['BoatController', 'BookingController'],
      }),
      getByBookableTypeAndSlug: build.query<
        GetByBookableTypeAndSlugApiResponse,
        GetByBookableTypeAndSlugApiArg
      >({
        query: (queryArg) => ({
          url: `/${queryArg.bookableType}/${queryArg.slug}`,
        }),
        providesTags: [
          'BoatController',
          'ExperienceController',
          'PropertyController',
        ],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as ellipsisApi };
export type GetAuthMagicApiResponse = unknown;
export type GetAuthMagicApiArg = {
  token?: string;
};
export type GetBedTypesByIdApiResponse =
  /** status 200 Bed Type model instance */ BedTypeWithRelations;
export type GetBedTypesByIdApiArg = {
  id: string;
  filter?: any;
};
export type GetBedTypesApiResponse =
  /** status 200 Array of Bed Type model instances */ BedTypeWithRelations[];
export type GetBedTypesApiArg = {
  filter?: any;
};
export type GetBoatEquipmentApiResponse =
  /** status 200 Array of Boat Equipment model instances */ BoatEquipmentWithRelations[];
export type GetBoatEquipmentApiArg = {
  bookableTypes?: string;
};
export type GetBoatsAvailableApiResponse =
  /** status 200 Get Boats with availability */ BoatWithRelations[];
export type GetBoatsAvailableApiArg = void;
export type GetBoatsCountApiResponse =
  /** status 200 Boat model count */ LoopbackCount;
export type GetBoatsCountApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minLength?: number;
  maxLength?: number;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  port?: string;
  numberOfPeople?: string;
  numberOfCabins?: string;
  startDate?: string;
  endDate?: string;
};
export type PostBoatsDenyByIdApiResponse =
  /** status 204 Verify Boat by Id */ Boat;
export type PostBoatsDenyByIdApiArg = {
  id: string;
};
export type GetBoatsLocationsApiResponse =
  /** status 200 Get distinct Boat Locations */ Location[];
export type GetBoatsLocationsApiArg = void;
export type GetBoatsManagerBoatsApiResponse =
  /** status 204 Get unverified Boats by Id */ Boat[];
export type GetBoatsManagerBoatsApiArg = void;
export type GetBoatsUnverifiedApiResponse =
  /** status 204 Get unverified Boats by Id */ Boat[];
export type GetBoatsUnverifiedApiArg = void;
export type GetBoatsVerifiedManagerWithBookingsApiResponse =
  /** status 204 Get verified manager boats with bookings */ BoatWithRelations[];
export type GetBoatsVerifiedManagerWithBookingsApiArg = void;
export type PostBoatsVerifyByIdApiResponse =
  /** status 204 Verify Boat by Id */ Boat;
export type PostBoatsVerifyByIdApiArg = {
  id: string;
};
export type PostBoatsByIdExtraOptionsApiResponse =
  /** status 200 Boat model instance */ ExtraOption;
export type PostBoatsByIdExtraOptionsApiArg = {
  id: string;
  newExtraOptionInBoat: NewExtraOptionInBoat;
};
export type PatchBoatsByIdExtraOptionsApiResponse =
  /** status 200 Boat.ExtraOption PATCH success count */ LoopbackCount;
export type PatchBoatsByIdExtraOptionsApiArg = {
  id: string;
  where?: any;
  extraOptionPartial: ExtraOptionPartial;
};
export type GetBoatsByIdExtraOptionsApiResponse =
  /** status 200 Array of Boat has many ExtraOption */ ExtraOption[];
export type GetBoatsByIdExtraOptionsApiArg = {
  id: string;
  filter?: any;
};
export type DeleteBoatsByIdExtraOptionsApiResponse =
  /** status 200 Boat.ExtraOption DELETE success count */ LoopbackCount;
export type DeleteBoatsByIdExtraOptionsApiArg = {
  id: string;
  where?: any;
};
export type PutBoatsByIdApiResponse = /** status 204 No Content */ any;
export type PutBoatsByIdApiArg = {
  id: string;
  boat: Boat;
};
export type PatchBoatsByIdApiResponse =
  /** status 204 Update Boat by Id */ BoatPartial;
export type PatchBoatsByIdApiArg = {
  id: string;
  brand?: string;
  boatPartial: BoatPartial;
};
export type GetBoatsByIdApiResponse =
  /** status 200 Boat model instance */ BoatWithRelations;
export type GetBoatsByIdApiArg = {
  id: string;
};
export type DeleteBoatsByIdApiResponse =
  /** status 204 Delete Boat by Id */ Boat;
export type DeleteBoatsByIdApiArg = {
  id: string;
};
export type PostBoatsApiResponse = /** status 200 Boat model instance */ Boat;
export type PostBoatsApiArg = {
  brand?: string;
  boat: Boat;
};
export type PatchBoatsApiResponse =
  /** status 200 Boat PATCH success count */ LoopbackCount;
export type PatchBoatsApiArg = {
  where?: any;
  boatPartial: BoatPartial;
};
export type GetBoatsApiResponse =
  /** status 200 Array of Boat model instances */ BoatWithRelations[];
export type GetBoatsApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minLength?: number;
  maxLength?: number;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  port?: string;
  numberOfPeople?: string;
  numberOfCabins?: string;
  startDate?: string;
  endDate?: string;
};
export type GetBookableAvailabilityByBookableTypeAndIdSelectedMonthSelectedYearApiResponse =
  /** status 200 Availability of bookable */ DayAvailabilityResponse;
export type GetBookableAvailabilityByBookableTypeAndIdSelectedMonthSelectedYearApiArg =
  {
    bookableType: string;
    id: string;
    selectedMonth: string;
    selectedYear: string;
    discountCode?: string;
  };
export type PostBookableDeleteByIdAndBookableTypeApiResponse = unknown;
export type PostBookableDeleteByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
};
export type GetBookableFeaturedApiResponse =
  /** status 200 Array of featured bookables */ Bookable[];
export type GetBookableFeaturedApiArg = {
  limit?: string;
};
export type GetBookableGetByIdAndBookableTypeApiResponse = unknown;
export type GetBookableGetByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
};
export type GetBookableManagedByUserIdApiResponse =
  /** status 200 Array of bookables managed by a specified user */ Bookable[];
export type GetBookableManagedByUserIdApiArg = {
  userId: string;
};
export type GetBookableRecommendedByIdAndBookableTypeApiResponse =
  /** status 200 Bookable recommendations */ RecommendedBookable[];
export type GetBookableRecommendedByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
};
export type PatchBookableUpdateListingOrderApiResponse =
  /** status 200 Update listing order of bookables */ BookableOrderUpdateRequest[];
export type PatchBookableUpdateListingOrderApiArg = {
  bookableOrderUpdateRequest: BookableOrderUpdateRequest[];
};
export type PostBookableReviewsDenyByIdApiResponse = unknown;
export type PostBookableReviewsDenyByIdApiArg = {
  id: string;
};
export type GetBookableReviewsUnverifiedApiResponse =
  /** status 204 Get unverified BookableReviews */ BookableReview[];
export type GetBookableReviewsUnverifiedApiArg = void;
export type PostBookableReviewsVerifyByIdApiResponse = unknown;
export type PostBookableReviewsVerifyByIdApiArg = {
  id: string;
};
export type GetBookableReviewsByBookableIdApiResponse =
  /** status 200 Bookable reviews */ BookableReviewPartialWithRelations[];
export type GetBookableReviewsByBookableIdApiArg = {
  bookableId: string;
};
export type PostBookingCalculateTotalsApiResponse =
  /** status 200 Booking model instance */ Booking;
export type PostBookingCalculateTotalsApiArg = {
  newBooking: NewBooking;
};
export type PostBookingsAcceptByBookingIdApiResponse =
  /** status 200 Booking */ Booking;
export type PostBookingsAcceptByBookingIdApiArg = {
  bookingId: string;
  brand?: string;
};
export type GetBookingsAdminBookingsApiResponse =
  /** status 204 Get bookings for admin */ Booking[];
export type GetBookingsAdminBookingsApiArg = void;
export type PostBookingsCancelByBookingIdApiResponse =
  /** status 200 Cancel Booking */ Booking;
export type PostBookingsCancelByBookingIdApiArg = {
  bookingId: string;
  brand?: string;
};
export type GetBookingsCountApiResponse =
  /** status 200 Booking model count */ LoopbackCount;
export type GetBookingsCountApiArg = {
  where?: any;
};
export type PostBookingsExtendOfferByBookingIdApiResponse =
  /** status 200 Booking */ Booking;
export type PostBookingsExtendOfferByBookingIdApiArg = {
  bookingId: string;
  body: {
    offerExpiresAt?: string;
  };
};
export type GetBookingsManagerBookingsApiResponse =
  /** status 204 Get a managers bookings */ Booking[];
export type GetBookingsManagerBookingsApiArg = void;
export type PatchBookingsMarkAsPaidOutByBookingIdApiResponse =
  /** status 200 Mark a booking as paid out */ Booking;
export type PatchBookingsMarkAsPaidOutByBookingIdApiArg = {
  bookingId: string;
  brand?: string;
};
export type PatchBookingsMarkAsRefundedByBookingIdApiResponse =
  /** status 200 Mark a booking as refunded */ Booking;
export type PatchBookingsMarkAsRefundedByBookingIdApiArg = {
  bookingId: string;
  brand?: string;
};
export type GetBookingsMyBookingsApiResponse =
  /** status 204 Get a users bookings */ Booking[];
export type GetBookingsMyBookingsApiArg = void;
export type PostBookingsOffPlatformOfferApiResponse =
  /** status 200 Off-platform custom offer created */ {
    booking?: Booking;
    offerLink?: string;
    emailSent?: boolean;
  };
export type PostBookingsOffPlatformOfferApiArg = {
  brand?: string;
  /** A booking to offer. The transient `sendOfferEmail` flag (default true) controls whether the offer is emailed to offerRecipient.email, and `allowConflict` (default false) creates the offer even if its dates overlap existing bookings; neither is persisted on the booking. */
  body: NewOffPlatformOffer & {
    /** Email the offer to offerRecipient.email. Not persisted. */
    sendOfferEmail?: boolean;
    /** Create the offer even if its dates overlap existing bookings. Not persisted. */
    allowConflict?: boolean;
  };
};
export type GetBookingsPayoutsCountApiResponse =
  /** status 200 Payout model count */ number;
export type GetBookingsPayoutsCountApiArg = void;
export type GetBookingsPayoutsApiResponse =
  /** status 200 Array of Booking model instances */ BookingWithRelations[];
export type GetBookingsPayoutsApiArg = void;
export type GetBookingsRefundsApiResponse =
  /** status 200 Array of Booking model instances that need refunding */ BookingWithRelations[];
export type GetBookingsRefundsApiArg = void;
export type PostBookingsRejectByBookingIdApiResponse =
  /** status 200 Booking */ Booking;
export type PostBookingsRejectByBookingIdApiArg = {
  bookingId: string;
  brand?: string;
};
export type PostBookingsResendConfirmationByBookingIdApiResponse =
  /** status 200 Booking */ Booking;
export type PostBookingsResendConfirmationByBookingIdApiArg = {
  bookingId: string;
  brand?: string;
};
export type GetBookingsRevenueReportApiResponse =
  /** status 200 Revenue report grouped by operator with currency breakdowns */ {
    targetCurrency?: string;
    exchangeGeneratedAt?: string;
    operators?: {
      operatorId?: string;
      operatorName?: string;
      bookingCount?: number;
      guestCount?: number;
      totalRevenue?: number;
      targetCurrency?: string;
      bookables?: {
        bookableId?: string;
        bookableName?: string;
        bookingCount?: number;
        guestCount?: number;
        totalRevenue?: number;
        targetCurrency?: string;
        sourceBreakdown?: {
          sourceCurrency?: string;
          bookingCount?: number;
          guestCount?: number;
          subtotalSource?: number;
          exchangeRate?: number;
          subtotalTarget?: number;
        }[];
      }[];
    }[];
    grandTotal?: {
      totalRevenue?: number;
      bookingCount?: number;
      guestCount?: number;
      sourceBreakdown?: {
        sourceCurrency?: string;
        bookingCount?: number;
        guestCount?: number;
        subtotalSource?: number;
        exchangeRate?: number;
        subtotalTarget?: number;
      }[];
    };
  };
export type GetBookingsRevenueReportApiArg = {
  startDate?: string;
  endDate?: string;
  operatorId?: string;
  bookableType?: string;
  targetCurrency?: string;
};
export type PostBookingsRevokeOfferByBookingIdApiResponse =
  /** status 200 Booking */ Booking;
export type PostBookingsRevokeOfferByBookingIdApiArg = {
  bookingId: string;
};
export type GetBookingsStripeIntentByIdApiResponse =
  /** status 200 Get Booking from stripe intent Id */ BookingWithRelations;
export type GetBookingsStripeIntentByIdApiArg = {
  id: string;
};
export type PatchBookingsUpdateBookingStatusByIdApiResponse = unknown;
export type PatchBookingsUpdateBookingStatusByIdApiArg = {
  id: string;
  brand?: string;
};
export type GetBookingsByIdClientSecretApiResponse =
  /** status 200 Booking intent Client Secret */ ClientSecret;
export type GetBookingsByIdClientSecretApiArg = {
  id: string;
};
export type PostBookingsByIdResendKeyholderEmailApiResponse =
  /** status 200 Resend keyholder emails */ boolean;
export type PostBookingsByIdResendKeyholderEmailApiArg = {
  id: string;
  brand?: string;
};
export type PostBookingsByIdSetupIntentsApiResponse =
  /** status 200 Updated Booking model instance */ boolean;
export type PostBookingsByIdSetupIntentsApiArg = {
  id: string;
};
export type GetBookingsByIdValidateAvailableApiResponse =
  /** status 200 Validate a booking is available */ boolean;
export type GetBookingsByIdValidateAvailableApiArg = {
  id: string;
};
export type PutBookingsByIdApiResponse = unknown;
export type PutBookingsByIdApiArg = {
  id: string;
  booking: Booking;
};
export type PatchBookingsByIdApiResponse =
  /** status 200 Updated Booking model instance */ Booking;
export type PatchBookingsByIdApiArg = {
  id: string;
  updatedBooking: UpdatedBooking;
};
export type GetBookingsByIdApiResponse =
  /** status 200 Booking model instance */ BookingWithRelations;
export type GetBookingsByIdApiArg = {
  id: string;
};
export type DeleteBookingsByIdApiResponse = unknown;
export type DeleteBookingsByIdApiArg = {
  id: string;
};
export type PostBookingsApiResponse =
  /** status 200 Booking model instance */ Booking;
export type PostBookingsApiArg = {
  brand?: string;
  newBooking: NewBooking;
};
export type PatchBookingsApiResponse =
  /** status 200 Booking PATCH success count */ LoopbackCount;
export type PatchBookingsApiArg = {
  where?: any;
  bookingPartial: BookingPartial;
};
export type GetBookingsApiResponse =
  /** status 200 Array of Booking model instances */ BookingWithRelations[];
export type GetBookingsApiArg = {
  filter?: any;
};
export type GetBookingsInProgressByBookableIdApiResponse =
  /** status 200 The most recent in progress booking of a user */ BookingWithRelations;
export type GetBookingsInProgressByBookableIdApiArg = {
  bookableId: string;
};
export type GetCalendarsByIdAndBookableTypeApiResponse =
  /** status 200 Get calendars on google account */ Calendar[];
export type GetCalendarsByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
};
export type GetCategoriesCountApiResponse =
  /** status 200 Category model count */ LoopbackCount;
export type GetCategoriesCountApiArg = {
  where?: any;
};
export type PutCategoriesByIdApiResponse = /** status 204 No Content */ any;
export type PutCategoriesByIdApiArg = {
  id: string;
  category: Category;
};
export type PatchCategoriesByIdApiResponse = /** status 204 No Content */ any;
export type PatchCategoriesByIdApiArg = {
  id: string;
  categoryPartial: CategoryPartial;
};
export type GetCategoriesByIdApiResponse =
  /** status 200 Category model instance */ CategoryWithRelations;
export type GetCategoriesByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteCategoriesByIdApiResponse = /** status 204 No Content */ any;
export type DeleteCategoriesByIdApiArg = {
  id: string;
};
export type PostCategoriesApiResponse =
  /** status 200 Category model instance */ Category;
export type PostCategoriesApiArg = {
  newCategory: NewCategory;
};
export type PatchCategoriesApiResponse =
  /** status 200 Category PATCH success count */ LoopbackCount;
export type PatchCategoriesApiArg = {
  where?: any;
  categoryPartial: CategoryPartial;
};
export type GetCategoriesApiResponse =
  /** status 200 Array of Category model instances */ CategoryWithRelations[];
export type GetCategoriesApiArg = {
  bookableTypes?: string;
};
export type GetContentCountApiResponse =
  /** status 200 Content model count */ LoopbackCount;
export type GetContentCountApiArg = {
  where?: any;
};
export type PutContentByIdApiResponse = /** status 204 No Content */ any;
export type PutContentByIdApiArg = {
  id: string;
  content: Content;
};
export type PatchContentByIdApiResponse = /** status 204 No Content */ any;
export type PatchContentByIdApiArg = {
  id: string;
  contentPartial: ContentPartial;
};
export type GetContentByIdApiResponse =
  /** status 200 Content model instance */ ContentWithRelations;
export type GetContentByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteContentByIdApiResponse = /** status 204 No Content */ any;
export type DeleteContentByIdApiArg = {
  id: string;
};
export type PostContentApiResponse =
  /** status 200 Content model instance */ Content;
export type PostContentApiArg = {
  newContent: NewContent;
};
export type PatchContentApiResponse =
  /** status 200 Content PATCH success count */ LoopbackCount;
export type PatchContentApiArg = {
  where?: any;
  contentPartial: ContentPartial;
};
export type GetContentApiResponse =
  /** status 200 Array of Content model instances */ ContentWithRelations[];
export type GetContentApiArg = {
  filter?: any;
};
export type GetConversationsCountApiResponse =
  /** status 200 Conversation model count */ LoopbackCount;
export type GetConversationsCountApiArg = {
  where?: any;
};
export type PutConversationsByIdApiResponse = unknown;
export type PutConversationsByIdApiArg = {
  id: string;
  conversation: Conversation;
};
export type PatchConversationsByIdApiResponse = unknown;
export type PatchConversationsByIdApiArg = {
  id: string;
  conversationPartial: ConversationPartial;
};
export type GetConversationsByIdApiResponse =
  /** status 200 Conversation model instance */ ConversationWithRelations;
export type GetConversationsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteConversationsByIdApiResponse = unknown;
export type DeleteConversationsByIdApiArg = {
  id: string;
};
export type PostConversationsApiResponse =
  /** status 200 Conversation model instance */ Conversation;
export type PostConversationsApiArg = {
  newConversation: NewConversation;
};
export type PatchConversationsApiResponse =
  /** status 200 Conversation PATCH success count */ LoopbackCount;
export type PatchConversationsApiArg = {
  where?: any;
  conversationPartial: ConversationPartial;
};
export type GetCurlApiResponse = unknown;
export type GetCurlApiArg = void;
export type GetExchangeRatesApiResponse =
  /** status 200 Conversion rates between the supported currencies, one entry per base currency */ ExchangeRate[];
export type GetExchangeRatesApiArg = void;
export type GetExperiencesCountApiResponse =
  /** status 200 Experience model count */ LoopbackCount;
export type GetExperiencesCountApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  numberOfPeople?: string;
  startDate?: string;
  endDate?: string;
};
export type PostExperiencesDenyByIdApiResponse =
  /** status 204 Verify Experience by Id */ Experience;
export type PostExperiencesDenyByIdApiArg = {
  id: string;
};
export type GetExperiencesFeaturedApiResponse =
  /** status 200 Array of featured experiences */ ExperienceWithRelations;
export type GetExperiencesFeaturedApiArg = void;
export type GetExperiencesLocationsApiResponse =
  /** status 200 Get distinct Experience Locations */ Location[];
export type GetExperiencesLocationsApiArg = void;
export type GetExperiencesManagerExperiencesApiResponse =
  /** status 204 Get manager Experiences by Id */ Experience[];
export type GetExperiencesManagerExperiencesApiArg = void;
export type GetExperiencesUnverifiedApiResponse =
  /** status 204 Get unverified Experiences by Id */ Experience[];
export type GetExperiencesUnverifiedApiArg = void;
export type GetExperiencesVerifiedManagerWithBookingsApiResponse =
  /** status 204 Get verified manager experiences with bookings */ BoatWithRelations[];
export type GetExperiencesVerifiedManagerWithBookingsApiArg = void;
export type PostExperiencesVerifyByIdApiResponse =
  /** status 204 Verify Experience by Id */ Experience;
export type PostExperiencesVerifyByIdApiArg = {
  id: string;
};
export type PutExperiencesByIdApiResponse = /** status 204 No Content */ any;
export type PutExperiencesByIdApiArg = {
  id: string;
  experience: Experience;
};
export type PatchExperiencesByIdApiResponse =
  /** status 204 Update Experience by Id */ ExperiencePartial;
export type PatchExperiencesByIdApiArg = {
  id: string;
  brand?: string;
  experiencePartial: ExperiencePartial;
};
export type GetExperiencesByIdApiResponse =
  /** status 200 Experience model instance */ ExperienceWithRelations;
export type GetExperiencesByIdApiArg = {
  id: string;
};
export type DeleteExperiencesByIdApiResponse =
  /** status 204 Delete Experience by Id */ Experience;
export type DeleteExperiencesByIdApiArg = {
  id: string;
};
export type PostExperiencesApiResponse =
  /** status 200 Experience model instance */ Experience;
export type PostExperiencesApiArg = {
  brand?: string;
  experience: Experience;
};
export type PatchExperiencesApiResponse =
  /** status 200 Experience PATCH success count */ LoopbackCount;
export type PatchExperiencesApiArg = {
  where?: any;
  experiencePartial: ExperiencePartial;
};
export type GetExperiencesApiResponse =
  /** status 200 Array of Experience model instances */ ExperienceWithRelations[];
export type GetExperiencesApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  numberOfPeople?: string;
  startDate?: string;
  endDate?: string;
};
export type GetExtraOptionCategoriesApiResponse =
  /** status 200 Get all extra option categories */ ExtraOptionCategory[];
export type GetExtraOptionCategoriesApiArg = {
  bookableTypes?: string;
};
export type GetExtraOptionTypesByIdExtraOptionCategoryApiResponse =
  /** status 200 ExtraOptionCategory belonging to ExtraOptionType */ ExtraOptionCategory[];
export type GetExtraOptionTypesByIdExtraOptionCategoryApiArg = {
  id: string;
};
export type GetExtraOptionTypesApiResponse =
  /** status 200 Get all extra option types */ ExtraOptionType[];
export type GetExtraOptionTypesApiArg = void;
export type GetFaqsApiResponse =
  /** status 200 Array of faq model instances */ Faq[];
export type GetFaqsApiArg = void;
export type GetFeedsBookablesGoogleAdsTsvApiResponse = unknown;
export type GetFeedsBookablesGoogleAdsTsvApiArg = void;
export type GetFeedsBookablesTsvApiResponse = unknown;
export type GetFeedsBookablesTsvApiArg = void;
export type GetHasReviewedByBookingIdApiResponse =
  /** status 200 has reviewed returns true if user has reviewed booking */ HasReviewed;
export type GetHasReviewedByBookingIdApiArg = {
  bookingId: string;
};
export type GetIsUserByEmailApiResponse =
  /** status 200 Is User returns true if email exists */ XTypescriptType;
export type GetIsUserByEmailApiArg = {
  email: string;
};
export type GetLocationsCountApiResponse =
  /** status 200 Location model count */ LoopbackCount;
export type GetLocationsCountApiArg = {
  where?: any;
};
export type PutLocationsByIdApiResponse = /** status 204 No Content */ any;
export type PutLocationsByIdApiArg = {
  id: string;
  location: Location;
};
export type PatchLocationsByIdApiResponse = /** status 204 No Content */ any;
export type PatchLocationsByIdApiArg = {
  id: string;
  locationPartial: LocationPartial;
};
export type GetLocationsByIdApiResponse =
  /** status 200 Location model instance */ LocationWithRelations;
export type GetLocationsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteLocationsByIdApiResponse = /** status 204 No Content */ any;
export type DeleteLocationsByIdApiArg = {
  id: string;
};
export type PostLocationsApiResponse =
  /** status 200 Location model instance */ Location;
export type PostLocationsApiArg = {
  newLocation: NewLocation;
};
export type PatchLocationsApiResponse =
  /** status 200 Location PATCH success count */ LoopbackCount;
export type PatchLocationsApiArg = {
  where?: any;
  locationPartial: LocationPartial;
};
export type GetLocationsApiResponse =
  /** status 200 Array of Location model instances */ LocationWithRelations[];
export type GetLocationsApiArg = {
  filter?: any;
};
export type DeleteMediaCloudflareDeleteByIdApiResponse =
  /** status 200 Delete media object uploaded to cloudflare */ MediaWithRelations;
export type DeleteMediaCloudflareDeleteByIdApiArg = {
  id: string;
};
export type GetMediaCloudflareUploadApiResponse =
  /** status 200 Get URL for cloudflare video upload */ UploadUrl;
export type GetMediaCloudflareUploadApiArg = void;
export type GetMediaUploadUrlByStageAndFilenameFilesizeApiResponse =
  /** status 200 Get URL for S3 file upload */ UploadUrl;
export type GetMediaUploadUrlByStageAndFilenameFilesizeApiArg = {
  stage: string;
  filename: string;
  filesize: string;
};
export type DeleteMediaByIdAndStageApiResponse =
  /** status 200 Boat model instance */ MediaWithRelations;
export type DeleteMediaByIdAndStageApiArg = {
  id: string;
  stage: string;
};
export type PostMediaApiResponse = /** status 200 Boat model instance */ Media;
export type PostMediaApiArg = {
  media: Media;
};
export type GetMessagesCountApiResponse =
  /** status 200 Message model count */ LoopbackCount;
export type GetMessagesCountApiArg = {
  where?: any;
};
export type GetMessagesByIdOriginalApiResponse =
  /** status 200 Original content for a message (admin only) */ {
    id?: string;
    hasOriginal?: boolean;
    original?: string;
    moderationStatus?: string;
  };
export type GetMessagesByIdOriginalApiArg = {
  id: string;
};
export type PatchMessagesByIdReadReceiptApiResponse =
  /** status 200 Message read receipt update success */ Message;
export type PatchMessagesByIdReadReceiptApiArg = {
  id: string;
};
export type PostMessagesByIdReapplyModerationApiResponse =
  /** status 200 Re-apply AI moderation to the original content (admin only) */ Message;
export type PostMessagesByIdReapplyModerationApiArg = {
  id: string;
  body: {
    expectedUpdatedAt?: string;
  };
};
export type PostMessagesByIdRestoreOriginalApiResponse =
  /** status 200 Restore original content into current message (admin only) */ Message;
export type PostMessagesByIdRestoreOriginalApiArg = {
  id: string;
  body: {
    reason?: string;
    expectedUpdatedAt?: string;
  };
};
export type PutMessagesByIdApiResponse = /** status 204 No Content */ any;
export type PutMessagesByIdApiArg = {
  id: string;
  message: Message;
};
export type PatchMessagesByIdApiResponse = /** status 204 No Content */ any;
export type PatchMessagesByIdApiArg = {
  id: string;
  messagePartial: MessagePartial;
};
export type GetMessagesByIdApiResponse =
  /** status 200 Message model instance */ MessageWithRelations;
export type GetMessagesByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteMessagesByIdApiResponse = /** status 204 No Content */ any;
export type DeleteMessagesByIdApiArg = {
  id: string;
};
export type PostMessagesApiResponse =
  /** status 200 Message model instance */ Message;
export type PostMessagesApiArg = {
  newMessage: NewMessage;
};
export type PatchMessagesApiResponse =
  /** status 200 Message PATCH success count */ LoopbackCount;
export type PatchMessagesApiArg = {
  where?: any;
  messagePartial: MessagePartial;
};
export type GetMessagesApiResponse =
  /** status 200 Array of Message model instances */ MessageWithRelations[];
export type GetMessagesApiArg = {
  filter?: any;
};
export type GetOauthUrlByIdAndBookableTypeApiResponse =
  /** status 200 Get URL for S3 file upload */ OauthUrl;
export type GetOauthUrlByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
};
export type GetOffersByTokenApiResponse =
  /** status 200 Public off-platform offer detail (token-scoped) */ object;
export type GetOffersByTokenApiArg = {
  token: string;
};
export type GetPasswordResetIsResetLinkValidByResetIdApiResponse = unknown;
export type GetPasswordResetIsResetLinkValidByResetIdApiArg = {
  resetId: string;
};
export type PostPasswordResetRequestByUserEmailApiResponse = unknown;
export type PostPasswordResetRequestByUserEmailApiArg = {
  userEmail: string;
  brand?: string;
};
export type PostPasswordResetResetPasswordApiResponse = unknown;
export type PostPasswordResetResetPasswordApiArg = {
  /** The input for the reset password function */
  body: {
    resetRequestId: string;
    password: string;
  };
};
export type PatchPayoutDetailsByIdApiResponse =
  /** status 204 Update payout details by Id */ PayoutDetails;
export type PatchPayoutDetailsByIdApiArg = {
  id: string;
  payoutDetails: PayoutDetails;
};
export type GetPayoutDetailsByUserIdApiResponse =
  /** status 200 Payout details for a user by userId */ PayoutDetails;
export type GetPayoutDetailsByUserIdApiArg = {
  userId: string;
};
export type PostPayoutDetailsApiResponse =
  /** status 200 Add payout details for a user */ Boat;
export type PostPayoutDetailsApiArg = {
  payoutDetails: PayoutDetails;
};
export type GetPayoutDetailsApiResponse =
  /** status 200 Existing payout details for a user */ PayoutDetails[];
export type GetPayoutDetailsApiArg = void;
export type GetPingApiResponse = /** status 200 Ping Response */ PingResponse;
export type GetPingApiArg = void;
export type GetPortsCountApiResponse =
  /** status 200 Port model count */ LoopbackCount;
export type GetPortsCountApiArg = {
  where?: any;
};
export type PutPortsByIdApiResponse = /** status 204 No Content */ any;
export type PutPortsByIdApiArg = {
  id: string;
  port: Port;
};
export type PatchPortsByIdApiResponse = /** status 204 No Content */ any;
export type PatchPortsByIdApiArg = {
  id: string;
  portPartial: PortPartial;
};
export type GetPortsByIdApiResponse =
  /** status 200 Port model instance */ PortWithRelations;
export type GetPortsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeletePortsByIdApiResponse = /** status 204 No Content */ any;
export type DeletePortsByIdApiArg = {
  id: string;
};
export type PostPortsApiResponse = /** status 200 Port model instance */ Port;
export type PostPortsApiArg = {
  newPort: NewPort;
};
export type PatchPortsApiResponse =
  /** status 200 Port PATCH success count */ LoopbackCount;
export type PatchPortsApiArg = {
  where?: any;
  portPartial: PortPartial;
};
export type GetPortsApiResponse =
  /** status 200 Array of Port model instances */ PortWithRelations[];
export type GetPortsApiArg = {
  filter?: any;
};
export type GetPropertiesCountApiResponse =
  /** status 200 Property model count */ LoopbackCount;
export type GetPropertiesCountApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  numberOfPeople?: string;
  numberOfRooms?: string;
  startDate?: string;
  endDate?: string;
};
export type PostPropertiesDenyByIdApiResponse =
  /** status 204 Verify Property by Id */ Property;
export type PostPropertiesDenyByIdApiArg = {
  id: string;
};
export type GetPropertiesLocationsApiResponse =
  /** status 200 Get distinct Property Locations */ Location[];
export type GetPropertiesLocationsApiArg = void;
export type GetPropertiesManagerPropertiesApiResponse =
  /** status 204 Get unverified Properties by Id */ Property[];
export type GetPropertiesManagerPropertiesApiArg = void;
export type GetPropertiesUnverifiedApiResponse =
  /** status 204 Get unverified Property by Id */ Property[];
export type GetPropertiesUnverifiedApiArg = void;
export type GetPropertiesVerifiedManagerWithBookingsApiResponse =
  /** status 204 Get verified manager properties with bookings */ PropertyWithRelations[];
export type GetPropertiesVerifiedManagerWithBookingsApiArg = void;
export type PostPropertiesVerifyByIdApiResponse =
  /** status 204 Verify Property by Id */ Property;
export type PostPropertiesVerifyByIdApiArg = {
  id: string;
};
export type PutPropertiesByIdApiResponse = /** status 204 No Content */ any;
export type PutPropertiesByIdApiArg = {
  id: string;
  property: Property;
};
export type PatchPropertiesByIdApiResponse =
  /** status 204 Update Property by Id */ PropertyPartial;
export type PatchPropertiesByIdApiArg = {
  id: string;
  brand?: string;
  propertyPartial: PropertyPartial;
};
export type GetPropertiesByIdApiResponse =
  /** status 200 Property model instance */ PropertyWithRelations;
export type GetPropertiesByIdApiArg = {
  id: string;
};
export type DeletePropertiesByIdApiResponse =
  /** status 204 Delete Property by Id */ Property;
export type DeletePropertiesByIdApiArg = {
  id: string;
};
export type PostPropertiesApiResponse =
  /** status 200 Property model instance */ Property;
export type PostPropertiesApiArg = {
  brand?: string;
  property: Property;
};
export type PatchPropertiesApiResponse =
  /** status 200 Property PATCH success count */ LoopbackCount;
export type PatchPropertiesApiArg = {
  where?: any;
  propertyPartial: PropertyPartial;
};
export type GetPropertiesApiResponse =
  /** status 200 Array of Property model instances */ PropertyWithRelations[];
export type GetPropertiesApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  numberOfPeople?: string;
  numberOfRooms?: string;
  startDate?: string;
  endDate?: string;
};
export type PostRemoveCalendarByIdAndBookableTypeApiResponse = unknown;
export type PostRemoveCalendarByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
};
export type GetRoutesCountApiResponse =
  /** status 200 Route model count */ LoopbackCount;
export type GetRoutesCountApiArg = {
  where?: any;
};
export type PutRoutesByIdApiResponse = /** status 204 No Content */ any;
export type PutRoutesByIdApiArg = {
  id: string;
  route: Route;
};
export type PatchRoutesByIdApiResponse = /** status 204 No Content */ any;
export type PatchRoutesByIdApiArg = {
  id: string;
  routePartial: RoutePartial;
};
export type GetRoutesByIdApiResponse =
  /** status 200 Route model instance */ RouteWithRelations;
export type GetRoutesByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteRoutesByIdApiResponse = /** status 204 No Content */ any;
export type DeleteRoutesByIdApiArg = {
  id: string;
};
export type PostRoutesApiResponse =
  /** status 200 Route model instance */ Route;
export type PostRoutesApiArg = {
  newRoute: NewRoute;
};
export type PatchRoutesApiResponse =
  /** status 200 Route PATCH success count */ LoopbackCount;
export type PatchRoutesApiArg = {
  where?: any;
  routePartial: RoutePartial;
};
export type GetRoutesApiResponse =
  /** status 200 Array of Route model instances */ RouteWithRelations[];
export type GetRoutesApiArg = {
  filter?: any;
};
export type GetSentEmailsCountApiResponse =
  /** status 200 EmailLog model count */ LoopbackCount;
export type GetSentEmailsCountApiArg = void;
export type GetSentEmailsApiResponse =
  /** status 200 Array of EmailLog model instances */ EmailLog[];
export type GetSentEmailsApiArg = {
  limit?: number;
  offset?: number;
};
export type PostSetCalendarAuthByIdAndBookableTypeCodeApiResponse = unknown;
export type PostSetCalendarAuthByIdAndBookableTypeCodeApiArg = {
  id: string;
  bookableType: string;
  code: string;
};
export type GetSitemapBookablesApiResponse =
  /** status 200 Public listings to include in the sitemap */ SitemapEntry[];
export type GetSitemapBookablesApiArg = void;
export type GetSkippersCountApiResponse =
  /** status 200 Skipper model count */ LoopbackCount;
export type GetSkippersCountApiArg = {
  where?: any;
};
export type PutSkippersByIdApiResponse = /** status 204 No Content */ any;
export type PutSkippersByIdApiArg = {
  id: string;
  skipper: Skipper;
};
export type PatchSkippersByIdApiResponse = /** status 204 No Content */ any;
export type PatchSkippersByIdApiArg = {
  id: string;
  skipperPartial: SkipperPartial;
};
export type GetSkippersByIdApiResponse =
  /** status 200 Skipper model instance */ SkipperWithRelations;
export type GetSkippersByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteSkippersByIdApiResponse = /** status 204 No Content */ any;
export type DeleteSkippersByIdApiArg = {
  id: string;
};
export type PostSkippersApiResponse =
  /** status 200 Skipper model instance */ Skipper;
export type PostSkippersApiArg = {
  newSkipper: NewSkipper;
};
export type PatchSkippersApiResponse =
  /** status 200 Skipper PATCH success count */ LoopbackCount;
export type PatchSkippersApiArg = {
  where?: any;
  skipperPartial: SkipperPartial;
};
export type GetSkippersApiResponse =
  /** status 200 Array of Skipper model instances */ SkipperWithRelations[];
export type GetSkippersApiArg = {
  filter?: any;
};
export type PostStripeConnectAccountLoginLinkApiResponse =
  /** status 200 Express dashboard link */ object;
export type PostStripeConnectAccountLoginLinkApiArg = void;
export type PostStripeConnectAccountSyncApiResponse =
  /** status 200 Synced account */ object;
export type PostStripeConnectAccountSyncApiArg = void;
export type PostStripeConnectAccountApiResponse =
  /** status 200 Onboarding link */ object;
export type PostStripeConnectAccountApiArg = void;
export type GetStripeConnectAccountApiResponse =
  /** status 200 Stripe Connect account of the caller */ object;
export type GetStripeConnectAccountApiArg = void;
export type GetStripeConnectAccountsByIdBookablesApiResponse =
  /** status 200 Listings managed by the account owner, plus any routed listing they no longer manage */ ConnectAccountBookable[];
export type GetStripeConnectAccountsByIdBookablesApiArg = {
  id: string;
};
export type PostStripeConnectAccountsByIdDisableApiResponse =
  /** status 200 Disabled account */ object;
export type PostStripeConnectAccountsByIdDisableApiArg = {
  id: string;
};
export type PatchStripeConnectAccountsByIdRoutingApiResponse =
  /** status 200 Updated account */ object;
export type PatchStripeConnectAccountsByIdRoutingApiArg = {
  id: string;
  body: {
    bookableId: string;
    enabled: boolean;
  };
};
export type PostStripeConnectAccountsByIdSyncApiResponse =
  /** status 200 Synced account */ object;
export type PostStripeConnectAccountsByIdSyncApiArg = {
  id: string;
};
export type PostStripeConnectAccountsApiResponse =
  /** status 200 Invited account */ object;
export type PostStripeConnectAccountsApiArg = {
  body: {
    userId: string;
    /** Default payout currency of the operator's Stripe account. Omitted on a new invite means gbp; omitted on a re-invite keeps the stored one. */
    defaultCurrency?: 'gbp' | 'eur' | 'usd';
  };
};
export type GetStripeConnectAccountsApiResponse =
  /** status 200 All Stripe Connect accounts */ object[];
export type GetStripeConnectAccountsApiArg = void;
export type GetStripeConnectBookingsByIdChargesApiResponse =
  /** status 200 Charges of a booking */ object;
export type GetStripeConnectBookingsByIdChargesApiArg = {
  id: string;
};
export type PostStripeConnectBookingsByIdRefundApiResponse =
  /** status 200 Refund created */ object;
export type PostStripeConnectBookingsByIdRefundApiArg = {
  id: string;
  body: {
    requestId: string;
    chargeId?: string;
    amount?: number;
    refundApplicationFee?: boolean;
    chargeOperatorForFee?: boolean;
  };
};
export type PostStripeConnectBookingsByIdReleasePayoutApiResponse =
  /** status 200 Per-item payout release results */ object[];
export type PostStripeConnectBookingsByIdReleasePayoutApiArg = {
  id: string;
  body: {
    force?: boolean;
  };
};
export type GetStripeConnectUsersSearchApiResponse =
  /** status 200 Users whose name or email contains q */ object[];
export type GetStripeConnectUsersSearchApiArg = {
  q?: string;
};
export type PostStripeConnectWebhookApiResponse = unknown;
export type PostStripeConnectWebhookApiArg = {
  body: object;
};
export type PostStripeWebhookApiResponse = unknown;
export type PostStripeWebhookApiArg = {
  body: object;
};
export type PostSubmitReviewApiResponse = unknown;
export type PostSubmitReviewApiArg = {
  /** The input for the create review function */
  body: {
    bookingId?: string;
    operatorReview?: UserReview;
    guestReview?: UserReview;
    bookableReview?: BookableReview;
  };
};
export type PostSyncCalendarByIdAndBookableTypeApiResponse =
  /** status 200 OK */ any;
export type PostSyncCalendarByIdAndBookableTypeApiArg = {
  id: string;
  bookableType: string;
  brand?: string;
};
export type GetTrackEmailOpenByEmailLogIdApiResponse = unknown;
export type GetTrackEmailOpenByEmailLogIdApiArg = {
  emailLogId: string;
};
export type PostUserReviewsDenyByIdApiResponse = unknown;
export type PostUserReviewsDenyByIdApiArg = {
  id: string;
};
export type GetUserReviewsUnverifiedApiResponse =
  /** status 204 Get unverified UserReview */ UserReview[];
export type GetUserReviewsUnverifiedApiArg = void;
export type PostUserReviewsVerifyByIdApiResponse = unknown;
export type PostUserReviewsVerifyByIdApiArg = {
  id: string;
};
export type GetUsersBookableIdApiResponse =
  /** status 200 Get user by bookableId */ User;
export type GetUsersBookableIdApiArg = {
  bookableId?: string;
  bookableType?: string;
};
export type PostUsersConfirmEmailApiResponse = /** status 200 User */ User;
export type PostUsersConfirmEmailApiArg = {
  brand?: string;
  /** The input of confirm email function */
  body: {
    verificationCode: string;
  };
};
export type GetUsersCountApiResponse =
  /** status 200 User model count */ LoopbackCount;
export type GetUsersCountApiArg = {
  where?: any;
};
export type PostUsersDenyByUserIdApiResponse = /** status 200 User */ User;
export type PostUsersDenyByUserIdApiArg = {
  userId: string;
  brand?: string;
};
export type GetUsersInfoByUserIdApiResponse = /** status 200 User info */ User;
export type GetUsersInfoByUserIdApiArg = {
  userId: string;
};
export type PostUsersLoginApiResponse = /** status 200 Token */ User;
export type PostUsersLoginApiArg = {
  /** The input of login function */
  body: {
    email: string;
    password: string;
  };
};
export type PostUsersLogoutApiResponse = unknown;
export type PostUsersLogoutApiArg = void;
export type PostUsersMeConsentApiResponse =
  /** status 200 Consent decision recorded */ UserConsentRecord;
export type PostUsersMeConsentApiArg = {
  /** Consent decision from the cookie banner */
  body: {
    decision: 'accepted' | 'declined';
    policyVersion: string;
    source?: 'banner' | 'preferences' | 'api';
    decidedAt?: string;
  };
};
export type GetUsersMeConsentApiResponse =
  /** status 200 The calling user's most recent consent decision */ UserConsentRecord;
export type GetUsersMeConsentApiArg = void;
export type GetUsersMeApiResponse = /** status 200 The current user */ User;
export type GetUsersMeApiArg = void;
export type PostUsersRequestOwnerAuthorisationApiResponse =
  /** status 200 User model count */ User;
export type PostUsersRequestOwnerAuthorisationApiArg = {
  brand?: string;
};
export type PostUsersResendConfirmEmailApiResponse =
  /** status 200 User */ User;
export type PostUsersResendConfirmEmailApiArg = {
  brand?: string;
};
export type PostUsersResetPasswordApiResponse = /** status 200 User */ User;
export type PostUsersResetPasswordApiArg = {
  /** The input of password reset function */
  body: {
    password: string;
    repeatPassword: string;
  };
};
export type GetUsersSearchBySearchApiResponse =
  /** status 200 Search Users */ User[];
export type GetUsersSearchBySearchApiArg = {
  search: string;
};
export type GetUsersUnverifiedApiResponse =
  /** status 200 Update User */ User[];
export type GetUsersUnverifiedApiArg = void;
export type PostUsersUpdateProfilePictureApiResponse =
  /** status 200 User */ User;
export type PostUsersUpdateProfilePictureApiArg = {
  /** The profilePicture id */
  body: {
    profilePictureId: string;
  };
};
export type PostUsersUpdateUserInfoApiResponse = /** status 200 User */ User;
export type PostUsersUpdateUserInfoApiArg = {
  /** The User info body */
  body: {
    biography: string;
    numberOfYearsExperience: number;
  };
};
export type GetUsersUserPrivateReviewsApiResponse =
  /** status 200 User reviews */ UserReviewPartialWithRelations[];
export type GetUsersUserPrivateReviewsApiArg = void;
export type GetUsersUserReviewsByUserIdApiResponse =
  /** status 200 User reviews */ UserReviewPartialWithRelations[];
export type GetUsersUserReviewsByUserIdApiArg = {
  userId: string;
};
export type PostUsersVerifyByUserIdApiResponse = /** status 200 User */ User;
export type PostUsersVerifyByUserIdApiArg = {
  userId: string;
  brand?: string;
};
export type GetUsersByUserIdConversationsApiResponse =
  /** status 200 User-scoped list of conversations with pagination and total count */ {
    conversations?: {
      id?: string;
      lastMessageTimestamp?: string;
      archived?: boolean;
      deleted?: boolean;
      conversationTopic?: {
        bookable?: {
          id?: string;
          type?: string;
          name?: string;
        };
        date?: {
          start?: string | null;
          end?: string | null;
        };
        operator?: {
          id?: string;
          name?: string | null;
        } | null;
      };
      participants?: {
        id?: string;
        name?: string;
        avatarUrl?: string | null;
      }[];
      /** Context messages: prefer at least one message from two different authors; otherwise return the latest ones. Ordered oldest→newest. */
      messages?: {
        id?: string;
        sentDate?: string;
        content?: string;
        author?: {
          id?: string;
          name?: string | null;
          avatarUrl?: string | null;
        };
      }[];
      preview?: {
        text?: string;
        hasAttachments?: boolean;
      };
    }[];
    total?: number;
  };
export type GetUsersByUserIdConversationsApiArg = {
  userId: string;
  archived?: string;
  sort?: string;
  limit?: number;
  skip?: number;
  lastMessageFrom?: string;
  lastMessageTo?: string;
  keywords?: string;
  includeDeleted?: boolean;
  messagesSampleSize?: number;
  messagesReturnCount?: number;
};
export type PutUsersByUserIdApiResponse = /** status 200 Update User */ User;
export type PutUsersByUserIdApiArg = {
  userId: string;
  user: User;
};
export type GetUsersByUserIdApiResponse = /** status 200 User */ User;
export type GetUsersByUserIdApiArg = {
  userId: string;
};
export type PostUsersApiResponse = /** status 200 User */ UserWithPassword;
export type PostUsersApiArg = {
  brand?: string;
  userWithPassword: UserWithPassword;
};
export type GetVehiclesCountApiResponse =
  /** status 200 Vehicle model count */ LoopbackCount;
export type GetVehiclesCountApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  numberOfPeople?: string;
  startDate?: string;
  endDate?: string;
};
export type GetVehiclesLocationsApiResponse =
  /** status 200 Get distinct Vehicle Locations */ Location[];
export type GetVehiclesLocationsApiArg = void;
export type GetVehiclesManagerVehiclesApiResponse =
  /** status 204 Get unverified vehicles */ Vehicle[];
export type GetVehiclesManagerVehiclesApiArg = void;
export type PostVehiclesRejectByIdApiResponse =
  /** status 204 Reject Vehicle by Id */ Vehicle;
export type PostVehiclesRejectByIdApiArg = {
  id: string;
};
export type GetVehiclesUnverifiedApiResponse =
  /** status 204 Get unverified Vehicles */ Vehicle[];
export type GetVehiclesUnverifiedApiArg = void;
export type GetVehiclesVerifiedManagerWithBookingsApiResponse =
  /** status 204 Get verified manager vehicles with bookings */ VehicleWithRelations[];
export type GetVehiclesVerifiedManagerWithBookingsApiArg = void;
export type PostVehiclesVerifyByIdApiResponse =
  /** status 204 Verify Vehicle by Id */ Vehicle;
export type PostVehiclesVerifyByIdApiArg = {
  id: string;
};
export type PutVehiclesByIdApiResponse = /** status 204 No Content */ any;
export type PutVehiclesByIdApiArg = {
  id: string;
  vehicle: Vehicle;
};
export type PatchVehiclesByIdApiResponse = /** status 204 No Content */ any;
export type PatchVehiclesByIdApiArg = {
  id: string;
  brand?: string;
  vehiclePartial: VehiclePartial;
};
export type GetVehiclesByIdApiResponse =
  /** status 200 Vehicle model instance */ VehicleWithRelations;
export type GetVehiclesByIdApiArg = {
  id: string;
};
export type DeleteVehiclesByIdApiResponse = /** status 204 No Content */ any;
export type DeleteVehiclesByIdApiArg = {
  id: string;
};
export type PostVehiclesApiResponse =
  /** status 200 Vehicle model instance */ Vehicle;
export type PostVehiclesApiArg = {
  brand?: string;
  newVehicle: NewVehicle;
};
export type GetVehiclesApiResponse =
  /** status 200 Array of Vehicle model instances */ VehicleWithRelations[];
export type GetVehiclesApiArg = {
  limit?: string;
  offset?: string;
  order?: string;
  desc?: string;
  featured?: boolean;
  category?: string;
  minRate?: string;
  maxRate?: string;
  currencyCode?: string;
  latlng?: string;
  distance?: string;
  location?: string;
  'location.division'?: string;
  numberOfPeople?: string;
  startDate?: string;
  endDate?: string;
};
export type GetWhoAmIApiResponse = /** status 200 Return current user */ {
  token?: string;
};
export type GetWhoAmIApiArg = void;
export type GetByBookableTypeAndSlugApiResponse = unknown;
export type GetByBookableTypeAndSlugApiArg = {
  bookableType: string;
  slug: string;
};
export type BedTypeWithRelations = {
  id?: string;
  name: string;
  icon: string;
  [key: string]: any;
};
export type BoatEquipmentWithRelations = {
  id?: string;
  name: string;
  group: string;
  icon?: string;
  bookableType?: string[];
  [key: string]: any;
};
export type Rate = {
  period?: string;
  value?: number;
  validFrom?: string;
  validTo?: string;
  validForever?: boolean;
  userIds?: string[];
  includedAdults?: number;
  includedChildren?: number;
  includedPeople?: number;
  [key: string]: any;
};
export type YearDate = {
  month?: number;
  day?: number;
  [key: string]: any;
};
export type RepeatDate = {
  repeatType?: string;
  repeatWeekly?: number[];
  repeatMonthly?: number[];
  repeatYearly?: YearDate[];
  [key: string]: any;
};
export type Point = {
  type: string;
  coordinates: number[];
  [key: string]: any;
};
export type Rating = {
  stars?: number;
  votes?: number;
};
export type Keyholder = {
  fullName?: string;
  contactNumber?: string;
  email: string;
  [key: string]: any;
};
export type Calendar = {
  calendarId?: string;
  etag?: string;
  summary?: string;
  description?: string;
  timeZone?: string;
  [key: string]: any;
};
export type CalendarAuth = {
  idToken?: string;
  refreshToken?: string;
  accessToken?: string;
  scope?: string;
  expiryDate?: number;
  email?: string;
  [key: string]: any;
};
export type LocationWithRelations = {
  id?: string;
  country: string;
  division: string;
  region: string;
  name: string;
  description?: string;
  geoCentre?: Point;
};
export type MediaWithRelations = {
  id?: string;
  type?: string;
  filename?: string;
  path: string;
  size?: number;
  altText: string;
  userId: string;
};
export type UserCredentialsWithRelations = {
  id?: string;
  password: string;
  userId: string;
};
export type UserRefreshTokenWithRelations = {
  id?: string;
  ttl: number;
  creation?: string;
  userId: string;
};
export type UserWithRelations = {
  id?: string;
  email: string;
  emailVerified?: boolean;
  verificationCode?: string;
  name?: string;
  roles?: string[];
  previousToken?: string;
  rating?: Rating;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  stripeCustomerId?: object[];
  brand?: string;
  /** Reusable magic login token for passwordless login via email links. Never expires by product request. */
  magicLoginToken?: string;
  userCredentials?: UserCredentialsWithRelations;
  userRefreshTokens?: UserRefreshTokenWithRelations[];
  profilePicture?: MediaWithRelations;
  foreignKey?: any;
};
export type CategoryWithRelations = {
  id?: string;
  type: string;
  bookableType?: string[];
  [key: string]: any;
};
export type BookingWithRelations = {
  id?: string;
  bookingRef?: string;
  startDate: string;
  endDate: string;
  numberOfPeople?: number;
  fullDays?: number;
  status: string;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  rate?: number;
  discountRate?: Rate;
  nonDiscountedRate?: number;
  skipperId?: string;
  paid?: boolean;
  payoutSent?: boolean;
  refundSent?: boolean;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  serviceCharge?: number;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  paymentIntentId?: string;
  setupIntentId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  estimatedPayout?: number;
  reviewSent?: boolean;
  discountCode?: string | null;
  offer?: boolean;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  priceOnRequest?: boolean;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerToken?: string;
  offerPrice?: number | null;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  offerViewedAt?: string | null;
  offerAcceptedAt?: string | null;
  offerRevokedAt?: string | null;
  user?: UserWithRelations;
  foreignKey?: any;
  [key: string]: any;
};
export type ReadReceipt = {
  userId: string;
  readDate: string;
  [key: string]: any;
};
export type MessageWithRelations = {
  id?: string;
  content: string;
  contentModerated?: string;
  originalContent?: string;
  contentOriginal?: string;
  isModerated?: boolean;
  moderationStatus?: 'none' | 'moderated' | 'restored';
  restoredBy?: string;
  restoredAt?: string;
  restorationReason?: string;
  conversationId: string;
  sentDate: string;
  updatedAt?: string;
  authoredByUserId?: string;
  readReceipts?: ReadReceipt[];
  authoredByUser?: UserWithRelations;
  foreignKey?: any;
  [key: string]: any;
};
export type ConversationWithRelations = {
  id?: string;
  archived?: boolean;
  deleted?: boolean;
  lastNotified?: string;
  statusChangedToArchivableDate?: string;
  createdByUserId?: string;
  participantUserIds?: string[];
  bookingId?: string;
  createdByUser?: UserWithRelations;
  foreignKey?: any;
  participantUsers?: UserWithRelations[];
  booking?: BookingWithRelations;
  messages?: MessageWithRelations[];
  [key: string]: any;
};
export type ExtraOptionCategoryWithRelations = {
  id?: string;
  name: string;
  description?: string;
  bookableType?: string[];
};
export type ExtraOptionTypeWithRelations = {
  id?: string;
  name: string;
  desc?: string;
  bookableType?: string[];
  extraOptionCategoryId?: string;
  extraOptionCategory?: ExtraOptionCategoryWithRelations;
  foreignKey?: any;
  [key: string]: any;
};
export type ExtraOptionWithRelations = {
  id?: string;
  description?: string;
  maxQuantity: number;
  price: number;
  payment: string;
  mandatory: boolean;
  chargeBasis: string;
  commission: number;
  extraOptionTypeId?: string;
  bookableId?: string;
  bookableType?: string;
  extraOptionType?: ExtraOptionTypeWithRelations;
  foreignKey?: any;
  [key: string]: any;
};
export type PortWithRelations = {
  id?: string;
  name: string;
  division?: string;
  country?: string;
  geoCentre?: Point;
};
export type BoatWithRelations = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  year?: string;
  capacity?: number;
  manufacturer?: string;
  lengthOfBoat?: number;
  numberOfCabins?: number;
  portId?: string;
  certificateId?: string;
  insuranceId?: string;
  location?: LocationWithRelations[];
  foreignKey?: any;
  mediaData?: MediaWithRelations[];
  managedByUser?: UserWithRelations;
  managers?: UserWithRelations[];
  category?: CategoryWithRelations[];
  bookings?: BookingWithRelations[];
  conversations?: ConversationWithRelations[];
  equipment?: BoatEquipmentWithRelations[];
  extraOptions?: ExtraOptionWithRelations[];
  port?: PortWithRelations;
  certificate?: MediaWithRelations;
  insurance?: MediaWithRelations;
  [key: string]: any;
};
export type LoopbackCount = {
  count?: number;
};
export type Boat = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  year?: string;
  capacity?: number;
  manufacturer?: string;
  lengthOfBoat?: number;
  numberOfCabins?: number;
  portId?: string;
  certificateId?: string;
  insuranceId?: string;
  [key: string]: any;
};
export type Location = {
  id?: string;
  country: string;
  division: string;
  region: string;
  name: string;
  description?: string;
  geoCentre?: Point;
};
export type ExtraOption = {
  id?: string;
  description?: string;
  maxQuantity: number;
  price: number;
  payment: string;
  mandatory: boolean;
  chargeBasis: string;
  commission: number;
  extraOptionTypeId?: string;
  bookableId?: string;
  bookableType?: string;
  [key: string]: any;
};
export type NewExtraOptionInBoat = {
  description?: string;
  maxQuantity: number;
  price: number;
  payment: string;
  mandatory: boolean;
  chargeBasis: string;
  commission: number;
  extraOptionTypeId?: string;
  bookableId?: string;
  bookableType?: string;
  [key: string]: any;
};
export type ExtraOptionPartial = {
  id?: string;
  description?: string;
  maxQuantity?: number;
  price?: number;
  payment?: string;
  mandatory?: boolean;
  chargeBasis?: string;
  commission?: number;
  extraOptionTypeId?: string;
  bookableId?: string;
  bookableType?: string;
  [key: string]: any;
};
export type BoatPartial = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  year?: string;
  capacity?: number;
  manufacturer?: string;
  lengthOfBoat?: number;
  numberOfCabins?: number;
  portId?: string;
  certificateId?: string;
  insuranceId?: string;
  [key: string]: any;
};
export type DayAvailability = {
  date?: string;
  period?: string[];
  sessionSpaces?: number[];
  [key: string]: any;
};
export type DayAvailabilityResponse = {
  startDate?: string;
  endDate?: string;
  availableDates?: DayAvailability[];
  [key: string]: any;
};
export type Bookable = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  [key: string]: any;
};
export type ScheduleClass = {
  start: string;
  end?: string;
  interval?: number;
  frequency?: string;
  duration?: number;
  count?: number;
  byHourOfDay?: number[];
  byDayOfWeek?: string[];
  byMinuteOfHour?: number[];
  isInfinite?: boolean;
  [key: string]: any;
};
export type Experience = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  sessionType?: string;
  minGuests?: number;
  maxGuests?: number;
  schedules?: ScheduleClass[];
  [key: string]: any;
};
export type Bed = {
  count: number;
  bedTypeId: string;
  [key: string]: any;
};
export type Property = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  numberOfPeople?: number;
  numberOfRooms?: number;
  numberOfBathrooms?: number;
  beds?: Bed[];
  [key: string]: any;
};
export type RecommendedBookable = {
  bookableType?: string;
  boat?: Boat;
  experience?: Experience;
  property?: Property;
  [key: string]: any;
};
export type BookableOrderUpdateRequest = {
  id?: string;
  listingOrder: number;
  bookableType: string;
};
export type BookableReview = {
  bookableId?: string;
  bookableType?: string;
  reviewerId?: string;
  rating: number;
  publicReview?: string;
  bookingId?: string;
  verified?: boolean;
  denied?: boolean;
  [key: string]: any;
};
export type UserCredentialsPartialWithRelations = {
  id?: string;
  password?: string;
  userId?: string;
};
export type UserRefreshTokenPartialWithRelations = {
  id?: string;
  ttl?: number;
  creation?: string;
  userId?: string;
};
export type MediaPartialWithRelations = {
  id?: string;
  type?: string;
  filename?: string;
  path?: string;
  size?: number;
  altText?: string;
  userId?: string;
};
export type UserPartialWithRelations = {
  id?: string;
  email?: string;
  emailVerified?: boolean;
  verificationCode?: string;
  name?: string;
  roles?: string[];
  previousToken?: string;
  rating?: Rating;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  stripeCustomerId?: object[];
  brand?: string;
  /** Reusable magic login token for passwordless login via email links. Never expires by product request. */
  magicLoginToken?: string;
  userCredentials?: UserCredentialsPartialWithRelations;
  userRefreshTokens?: UserRefreshTokenPartialWithRelations[];
  profilePicture?: MediaPartialWithRelations;
  foreignKey?: any;
};
export type BookingPartialWithRelations = {
  id?: string;
  bookingRef?: string;
  startDate?: string;
  endDate?: string;
  numberOfPeople?: number;
  fullDays?: number;
  status?: string;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  rate?: number;
  discountRate?: Rate;
  nonDiscountedRate?: number;
  skipperId?: string;
  paid?: boolean;
  payoutSent?: boolean;
  refundSent?: boolean;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  serviceCharge?: number;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  paymentIntentId?: string;
  setupIntentId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  estimatedPayout?: number;
  reviewSent?: boolean;
  discountCode?: string | null;
  offer?: boolean;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  priceOnRequest?: boolean;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerToken?: string;
  offerPrice?: number | null;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  offerViewedAt?: string | null;
  offerAcceptedAt?: string | null;
  offerRevokedAt?: string | null;
  user?: UserPartialWithRelations;
  foreignKey?: any;
  [key: string]: any;
};
export type BookableReviewPartialWithRelations = {
  id?: string;
  bookableId?: string;
  bookableType?: string;
  reviewerId?: string;
  rating?: number;
  publicReview?: string;
  bookingId?: string;
  verified?: boolean;
  denied?: boolean;
  reviewer?: UserPartialWithRelations;
  foreignKey?: any;
  booking?: BookingPartialWithRelations;
  [key: string]: any;
};
export type Booking = {
  id?: string;
  bookingRef?: string;
  startDate: string;
  endDate: string;
  numberOfPeople?: number;
  fullDays?: number;
  status: string;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  rate?: number;
  discountRate?: Rate;
  nonDiscountedRate?: number;
  skipperId?: string;
  paid?: boolean;
  payoutSent?: boolean;
  refundSent?: boolean;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  serviceCharge?: number;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  paymentIntentId?: string;
  setupIntentId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  estimatedPayout?: number;
  reviewSent?: boolean;
  discountCode?: string | null;
  offer?: boolean;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  priceOnRequest?: boolean;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerToken?: string;
  offerPrice?: number | null;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  offerViewedAt?: string | null;
  offerAcceptedAt?: string | null;
  offerRevokedAt?: string | null;
  [key: string]: any;
};
export type NewBooking = {
  bookingRef?: string;
  startDate: string;
  endDate: string;
  numberOfPeople?: number;
  fullDays?: number;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  discountRate?: Rate;
  nonDiscountedRate?: number;
  skipperId?: string;
  payoutSent?: boolean;
  refundSent?: boolean;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  serviceCharge?: number;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  paymentIntentId?: string;
  setupIntentId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  estimatedPayout?: number;
  reviewSent?: boolean;
  discountCode?: string | null;
  offer?: boolean;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  priceOnRequest?: boolean;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerToken?: string;
  offerPrice?: number | null;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  offerViewedAt?: string | null;
  offerAcceptedAt?: string | null;
  offerRevokedAt?: string | null;
  [key: string]: any;
};
export type NewOffPlatformOffer = {
  bookingRef?: string;
  startDate: string;
  endDate: string;
  numberOfPeople?: number;
  fullDays?: number;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  discountRate?: Rate;
  nonDiscountedRate?: number;
  skipperId?: string;
  payoutSent?: boolean;
  refundSent?: boolean;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  serviceCharge?: number;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  paymentIntentId?: string;
  setupIntentId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  estimatedPayout?: number;
  reviewSent?: boolean;
  discountCode?: string | null;
  offer?: boolean;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  priceOnRequest?: boolean;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerPrice?: number | null;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  [key: string]: any;
};
export type ClientSecret = {
  clientSecret?: string;
};
export type UpdatedBooking = {
  id?: string;
  bookingRef?: string;
  startDate?: string;
  endDate?: string;
  numberOfPeople?: number;
  fullDays?: number;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  nonDiscountedRate?: number;
  skipperId?: string;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  reviewSent?: boolean;
  discountCode?: string | null;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  offerViewedAt?: string | null;
  offerAcceptedAt?: string | null;
  offerRevokedAt?: string | null;
  [key: string]: any;
};
export type BookingPartial = {
  id?: string;
  bookingRef?: string;
  startDate?: string;
  endDate?: string;
  numberOfPeople?: number;
  fullDays?: number;
  status?: string;
  currencyCode?: string;
  conversionRate?: number | null;
  currencySymbol?: string;
  rate?: number;
  discountRate?: Rate;
  nonDiscountedRate?: number;
  skipperId?: string;
  paid?: boolean;
  payoutSent?: boolean;
  refundSent?: boolean;
  bookableId?: string;
  bookableType?: string;
  email?: string;
  serviceCharge?: number;
  bookingTotal?: number;
  installmentAmount?: number;
  installmentStartDate?: string;
  initialPrice?: number;
  initialPriceId?: string;
  numberOfInstallments?: number;
  userId?: string;
  paymentIntentId?: string;
  setupIntentId?: string;
  extraOptions?: object[];
  ownerMessage?: string;
  isHalfDay?: boolean | null;
  halfDayBookingTime?: string | null;
  estimatedPayout?: number;
  reviewSent?: boolean;
  discountCode?: string | null;
  offer?: boolean;
  isRevoked?: boolean;
  message?: string;
  brand?: string | null;
  priceOnRequest?: boolean;
  paymentDate?: string;
  selectedPaymentPlan?: boolean;
  selectedMonthlyInstallments?: boolean;
  offerToken?: string;
  offerPrice?: number | null;
  offerRecipient?: {
    email?: string;
    phone?: string;
    name?: string;
  };
  offerExpiresAt?: string | null;
  offerViewedAt?: string | null;
  offerAcceptedAt?: string | null;
  offerRevokedAt?: string | null;
  [key: string]: any;
};
export type Category = {
  id?: string;
  type: string;
  bookableType?: string[];
  [key: string]: any;
};
export type CategoryPartial = {
  id?: string;
  type?: string;
  bookableType?: string[];
  [key: string]: any;
};
export type NewCategory = {
  type: string;
  bookableType?: string[];
  [key: string]: any;
};
export type Content = {
  id?: string;
  title?: string;
  ogImage?: string;
  description?: string;
  locale?: string;
  cssStyles?: string;
  body: string;
  authoredByUserId?: string;
};
export type ContentPartial = {
  id?: string;
  title?: string;
  ogImage?: string;
  description?: string;
  locale?: string;
  cssStyles?: string;
  body?: string;
  authoredByUserId?: string;
};
export type ContentWithRelations = {
  id?: string;
  title?: string;
  ogImage?: string;
  description?: string;
  locale?: string;
  cssStyles?: string;
  body: string;
  authoredByUserId?: string;
  authoredByUser?: UserWithRelations;
  foreignKey?: any;
};
export type NewContent = {
  title?: string;
  ogImage?: string;
  description?: string;
  locale?: string;
  cssStyles?: string;
  body: string;
  authoredByUserId?: string;
};
export type Conversation = {
  id?: string;
  archived?: boolean;
  deleted?: boolean;
  lastNotified?: string;
  statusChangedToArchivableDate?: string;
  createdByUserId?: string;
  participantUserIds?: string[];
  bookingId?: string;
  [key: string]: any;
};
export type ConversationPartial = {
  id?: string;
  archived?: boolean;
  deleted?: boolean;
  lastNotified?: string;
  statusChangedToArchivableDate?: string;
  createdByUserId?: string;
  participantUserIds?: string[];
  bookingId?: string;
  [key: string]: any;
};
export type NewConversation = {
  archived?: boolean;
  deleted?: boolean;
  lastNotified?: string;
  statusChangedToArchivableDate?: string;
  createdByUserId?: string;
  participantUserIds?: string[];
  bookingId?: string;
  [key: string]: any;
};
export type ExchangeRate = {
  id: string;
  rates: {
    [key: string]: number;
  };
  source: string;
  fetchedAt: string;
};
export type ExperienceWithRelations = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  sessionType?: string;
  minGuests?: number;
  maxGuests?: number;
  schedules?: ScheduleClass[];
  location?: LocationWithRelations[];
  foreignKey?: any;
  mediaData?: MediaWithRelations[];
  managedByUser?: UserWithRelations;
  managers?: UserWithRelations[];
  category?: CategoryWithRelations[];
  bookings?: BookingWithRelations[];
  conversations?: ConversationWithRelations[];
  equipment?: BoatEquipmentWithRelations[];
  extraOptions?: ExtraOptionWithRelations[];
  [key: string]: any;
};
export type ExperiencePartial = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  sessionType?: string;
  minGuests?: number;
  maxGuests?: number;
  schedules?: ScheduleClass[];
  [key: string]: any;
};
export type ExtraOptionCategory = {
  id?: string;
  name: string;
  description?: string;
  bookableType?: string[];
};
export type ExtraOptionType = {
  id?: string;
  name: string;
  desc?: string;
  bookableType?: string[];
  extraOptionCategoryId?: string;
  [key: string]: any;
};
export type Faq = {
  id?: string;
  question: string;
  answer: string;
  weight: number;
  focus: string;
};
export type HasReviewed = {
  hasReviewed?: boolean;
};
export type XTypescriptType = {
  isUser?: boolean;
};
export type LocationPartial = {
  id?: string;
  country?: string;
  division?: string;
  region?: string;
  name?: string;
  description?: string;
  geoCentre?: Point;
};
export type NewLocation = {
  country: string;
  division: string;
  region: string;
  name: string;
  description?: string;
  geoCentre?: Point;
};
export type UploadUrl = {
  uploadUrl?: string;
};
export type Media = {
  id?: string;
  type?: string;
  filename?: string;
  path: string;
  size?: number;
  altText: string;
  userId: string;
};
export type Message = {
  id?: string;
  content: string;
  contentModerated?: string;
  originalContent?: string;
  contentOriginal?: string;
  isModerated?: boolean;
  moderationStatus?: 'none' | 'moderated' | 'restored';
  restoredBy?: string;
  restoredAt?: string;
  restorationReason?: string;
  conversationId: string;
  sentDate: string;
  updatedAt?: string;
  authoredByUserId?: string;
  readReceipts?: ReadReceipt[];
  [key: string]: any;
};
export type MessagePartial = {
  id?: string;
  content?: string;
  contentModerated?: string;
  originalContent?: string;
  contentOriginal?: string;
  isModerated?: boolean;
  moderationStatus?: 'none' | 'moderated' | 'restored';
  restoredBy?: string;
  restoredAt?: string;
  restorationReason?: string;
  conversationId?: string;
  sentDate?: string;
  updatedAt?: string;
  authoredByUserId?: string;
  readReceipts?: ReadReceipt[];
  [key: string]: any;
};
export type NewMessage = {
  content: string;
  contentModerated?: string;
  originalContent?: string;
  contentOriginal?: string;
  isModerated?: boolean;
  moderationStatus?: 'none' | 'moderated' | 'restored';
  restoredBy?: string;
  restoredAt?: string;
  restorationReason?: string;
  conversationId: string;
  sentDate: string;
  updatedAt?: string;
  authoredByUserId?: string;
  readReceipts?: ReadReceipt[];
  [key: string]: any;
};
export type OauthUrl = {
  url?: string;
};
export type PayoutDetails = {
  userId?: string;
  bankAccountCountry: string;
  bankAccountCurrency: string;
  swiftCode?: string;
  ibanNumber?: string;
  bankName?: string;
  accountNumber?: string;
};
export type PingResponse = {
  greeting?: string;
  date?: string;
  url?: string;
  headers?: {
    'Content-Type'?: string;
    [key: string]: any;
  };
};
export type Port = {
  id?: string;
  name: string;
  division?: string;
  country?: string;
  geoCentre?: Point;
};
export type PortPartial = {
  id?: string;
  name?: string;
  division?: string;
  country?: string;
  geoCentre?: Point;
};
export type NewPort = {
  name: string;
  division?: string;
  country?: string;
  geoCentre?: Point;
};
export type PropertyWithRelations = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  numberOfPeople?: number;
  numberOfRooms?: number;
  numberOfBathrooms?: number;
  beds?: Bed[];
  location?: LocationWithRelations[];
  foreignKey?: any;
  mediaData?: MediaWithRelations[];
  managedByUser?: UserWithRelations;
  managers?: UserWithRelations[];
  category?: CategoryWithRelations[];
  bookings?: BookingWithRelations[];
  conversations?: ConversationWithRelations[];
  equipment?: BoatEquipmentWithRelations[];
  extraOptions?: ExtraOptionWithRelations[];
  [key: string]: any;
};
export type PropertyPartial = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  numberOfPeople?: number;
  numberOfRooms?: number;
  numberOfBathrooms?: number;
  beds?: Bed[];
  [key: string]: any;
};
export type Parameter = {
  name?: string;
  value?: string;
  [key: string]: any;
};
export type Route = {
  id?: string;
  path: string;
  component: string;
  params?: Parameter[];
};
export type RoutePartial = {
  id?: string;
  path?: string;
  component?: string;
  params?: Parameter[];
};
export type RouteWithRelations = {
  id?: string;
  path: string;
  component: string;
  params?: Parameter[];
};
export type NewRoute = {
  path: string;
  component: string;
  params?: Parameter[];
};
export type EmailLog = {
  id?: string;
  recipientEmailAddress?: string;
  subject: string;
  content: string;
  opened?: boolean;
  openCount?: number;
  firstOpenedAt?: string;
};
export type SitemapEntry = {
  bookableType: string;
  id: string;
  slug?: string;
  lastModified: string;
};
export type Skipper = {
  id?: string;
  name?: string;
  email: string;
  emailVerified?: boolean;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  [key: string]: any;
};
export type SkipperPartial = {
  id?: string;
  name?: string;
  email?: string;
  emailVerified?: boolean;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  [key: string]: any;
};
export type SkipperWithRelations = {
  id?: string;
  name?: string;
  email: string;
  emailVerified?: boolean;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  profilePicture?: MediaWithRelations;
  foreignKey?: any;
  [key: string]: any;
};
export type NewSkipper = {
  name?: string;
  email: string;
  emailVerified?: boolean;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  [key: string]: any;
};
export type ConnectAccountBookable = {
  id: string;
  bookableType?: 'Boat' | 'Experience' | 'Property' | 'Vehicle';
  name?: string;
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  routed: boolean;
  managedByAccountUser: boolean;
};
export type UserReview = {
  userId?: string;
  reviewerId?: string;
  rating: number;
  publicReview?: string;
  privateFeedback?: string;
  bookingId?: string;
  verified?: boolean;
  denied?: boolean;
  [key: string]: any;
};
export type User = {
  id?: string;
  email: string;
  emailVerified?: boolean;
  verificationCode?: string;
  name?: string;
  roles?: string[];
  previousToken?: string;
  rating?: Rating;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  stripeCustomerId?: object[];
  brand?: string;
  /** Reusable magic login token for passwordless login via email links. Never expires by product request. */
  magicLoginToken?: string;
};
export type UserConsentRecord = {
  id?: string;
  userId: string;
  decision: 'accepted' | 'declined';
  policyVersion: string;
  decidedAt: string;
  source?: 'banner' | 'preferences' | 'api';
  [key: string]: any;
};
export type UserReviewPartialWithRelations = {
  id?: string;
  userId?: string;
  reviewerId?: string;
  rating?: number;
  publicReview?: string;
  privateFeedback?: string;
  bookingId?: string;
  verified?: boolean;
  denied?: boolean;
  user?: UserPartialWithRelations;
  foreignKey?: any;
  reviewer?: UserPartialWithRelations;
  booking?: BookingPartialWithRelations;
  [key: string]: any;
};
export type UserWithPassword = {
  email: string;
  verificationCode?: string;
  name?: string;
  rating?: Rating;
  numberOfYearsExperience?: number;
  profilePictureId?: string;
  biography?: string;
  stripeCustomerId?: object[];
  brand?: string;
  /** Reusable magic login token for passwordless login via email links. Never expires by product request. */
  magicLoginToken?: string;
  password: string;
};
export type Vehicle = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  licenceId?: string;
  insuranceId?: string;
  [key: string]: any;
};
export type VehicleWithRelations = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  licenceId?: string;
  insuranceId?: string;
  location?: LocationWithRelations[];
  foreignKey?: any;
  mediaData?: MediaWithRelations[];
  managedByUser?: UserWithRelations;
  managers?: UserWithRelations[];
  category?: CategoryWithRelations[];
  bookings?: BookingWithRelations[];
  conversations?: ConversationWithRelations[];
  equipment?: BoatEquipmentWithRelations[];
  extraOptions?: ExtraOptionWithRelations[];
  licence?: MediaWithRelations;
  insurance?: MediaWithRelations;
  [key: string]: any;
};
export type VehiclePartial = {
  id?: string;
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  licenceId?: string;
  insuranceId?: string;
  [key: string]: any;
};
export type NewVehicle = {
  bookableType?: string;
  name?: string;
  slug?: string;
  updatedAt?: string;
  scheduledStart?: number;
  scheduledEnd?: number;
  rate?: Rate[];
  draft?: boolean;
  verified?: boolean;
  deactivated?: boolean;
  deleted?: boolean;
  description?: string;
  cancellationPolicy?: string;
  shortDescription?: string;
  minBookingLength?: number;
  maxBookingLength?: number;
  area?: string;
  address?: string;
  noLicenceRequired?: boolean;
  locationIds?: string[];
  disabledDates?: string[];
  disabledRepeatDates?: RepeatDate[];
  positionHistory?: Point[];
  position?: Point;
  mediaDataIds?: string[];
  featured?: boolean;
  commission?: number;
  managedByUserId?: string;
  managerIds?: string[];
  categoryIds?: string[];
  currencyCode?: string;
  allowInstantBooking?: boolean;
  vatRegistered?: boolean;
  rating?: Rating;
  priceOnRequest?: boolean;
  keyholders?: Keyholder[];
  equipmentIds?: string[];
  joiningInstructions?: string;
  calendars?: Calendar[];
  calendarAuth?: CalendarAuth;
  insuranceDeclaration?: boolean;
  listingOrder?: number;
  licenceId?: string;
  insuranceId?: string;
  [key: string]: any;
};
export const {
  useGetAuthMagicQuery,
  useGetBedTypesByIdQuery,
  useGetBedTypesQuery,
  useGetBoatEquipmentQuery,
  useGetBoatsAvailableQuery,
  useGetBoatsCountQuery,
  usePostBoatsDenyByIdMutation,
  useGetBoatsLocationsQuery,
  useGetBoatsManagerBoatsQuery,
  useGetBoatsUnverifiedQuery,
  useGetBoatsVerifiedManagerWithBookingsQuery,
  usePostBoatsVerifyByIdMutation,
  usePostBoatsByIdExtraOptionsMutation,
  usePatchBoatsByIdExtraOptionsMutation,
  useGetBoatsByIdExtraOptionsQuery,
  useDeleteBoatsByIdExtraOptionsMutation,
  usePutBoatsByIdMutation,
  usePatchBoatsByIdMutation,
  useGetBoatsByIdQuery,
  useDeleteBoatsByIdMutation,
  usePostBoatsMutation,
  usePatchBoatsMutation,
  useGetBoatsQuery,
  useGetBookableAvailabilityByBookableTypeAndIdSelectedMonthSelectedYearQuery,
  usePostBookableDeleteByIdAndBookableTypeMutation,
  useGetBookableFeaturedQuery,
  useGetBookableGetByIdAndBookableTypeQuery,
  useGetBookableManagedByUserIdQuery,
  useGetBookableRecommendedByIdAndBookableTypeQuery,
  usePatchBookableUpdateListingOrderMutation,
  usePostBookableReviewsDenyByIdMutation,
  useGetBookableReviewsUnverifiedQuery,
  usePostBookableReviewsVerifyByIdMutation,
  useGetBookableReviewsByBookableIdQuery,
  usePostBookingCalculateTotalsMutation,
  usePostBookingsAcceptByBookingIdMutation,
  useGetBookingsAdminBookingsQuery,
  usePostBookingsCancelByBookingIdMutation,
  useGetBookingsCountQuery,
  usePostBookingsExtendOfferByBookingIdMutation,
  useGetBookingsManagerBookingsQuery,
  usePatchBookingsMarkAsPaidOutByBookingIdMutation,
  usePatchBookingsMarkAsRefundedByBookingIdMutation,
  useGetBookingsMyBookingsQuery,
  usePostBookingsOffPlatformOfferMutation,
  useGetBookingsPayoutsCountQuery,
  useGetBookingsPayoutsQuery,
  useGetBookingsRefundsQuery,
  usePostBookingsRejectByBookingIdMutation,
  usePostBookingsResendConfirmationByBookingIdMutation,
  useGetBookingsRevenueReportQuery,
  usePostBookingsRevokeOfferByBookingIdMutation,
  useGetBookingsStripeIntentByIdQuery,
  usePatchBookingsUpdateBookingStatusByIdMutation,
  useGetBookingsByIdClientSecretQuery,
  usePostBookingsByIdResendKeyholderEmailMutation,
  usePostBookingsByIdSetupIntentsMutation,
  useGetBookingsByIdValidateAvailableQuery,
  usePutBookingsByIdMutation,
  usePatchBookingsByIdMutation,
  useGetBookingsByIdQuery,
  useDeleteBookingsByIdMutation,
  usePostBookingsMutation,
  usePatchBookingsMutation,
  useGetBookingsQuery,
  useGetBookingsInProgressByBookableIdQuery,
  useGetCalendarsByIdAndBookableTypeQuery,
  useGetCategoriesCountQuery,
  usePutCategoriesByIdMutation,
  usePatchCategoriesByIdMutation,
  useGetCategoriesByIdQuery,
  useDeleteCategoriesByIdMutation,
  usePostCategoriesMutation,
  usePatchCategoriesMutation,
  useGetCategoriesQuery,
  useGetContentCountQuery,
  usePutContentByIdMutation,
  usePatchContentByIdMutation,
  useGetContentByIdQuery,
  useDeleteContentByIdMutation,
  usePostContentMutation,
  usePatchContentMutation,
  useGetContentQuery,
  useGetConversationsCountQuery,
  usePutConversationsByIdMutation,
  usePatchConversationsByIdMutation,
  useGetConversationsByIdQuery,
  useDeleteConversationsByIdMutation,
  usePostConversationsMutation,
  usePatchConversationsMutation,
  useGetCurlQuery,
  useGetExchangeRatesQuery,
  useGetExperiencesCountQuery,
  usePostExperiencesDenyByIdMutation,
  useGetExperiencesFeaturedQuery,
  useGetExperiencesLocationsQuery,
  useGetExperiencesManagerExperiencesQuery,
  useGetExperiencesUnverifiedQuery,
  useGetExperiencesVerifiedManagerWithBookingsQuery,
  usePostExperiencesVerifyByIdMutation,
  usePutExperiencesByIdMutation,
  usePatchExperiencesByIdMutation,
  useGetExperiencesByIdQuery,
  useDeleteExperiencesByIdMutation,
  usePostExperiencesMutation,
  usePatchExperiencesMutation,
  useGetExperiencesQuery,
  useGetExtraOptionCategoriesQuery,
  useGetExtraOptionTypesByIdExtraOptionCategoryQuery,
  useGetExtraOptionTypesQuery,
  useGetFaqsQuery,
  useGetFeedsBookablesGoogleAdsTsvQuery,
  useGetFeedsBookablesTsvQuery,
  useGetHasReviewedByBookingIdQuery,
  useGetIsUserByEmailQuery,
  useGetLocationsCountQuery,
  usePutLocationsByIdMutation,
  usePatchLocationsByIdMutation,
  useGetLocationsByIdQuery,
  useDeleteLocationsByIdMutation,
  usePostLocationsMutation,
  usePatchLocationsMutation,
  useGetLocationsQuery,
  useDeleteMediaCloudflareDeleteByIdMutation,
  useGetMediaCloudflareUploadQuery,
  useGetMediaUploadUrlByStageAndFilenameFilesizeQuery,
  useDeleteMediaByIdAndStageMutation,
  usePostMediaMutation,
  useGetMessagesCountQuery,
  useGetMessagesByIdOriginalQuery,
  usePatchMessagesByIdReadReceiptMutation,
  usePostMessagesByIdReapplyModerationMutation,
  usePostMessagesByIdRestoreOriginalMutation,
  usePutMessagesByIdMutation,
  usePatchMessagesByIdMutation,
  useGetMessagesByIdQuery,
  useDeleteMessagesByIdMutation,
  usePostMessagesMutation,
  usePatchMessagesMutation,
  useGetMessagesQuery,
  useGetOauthUrlByIdAndBookableTypeQuery,
  useGetOffersByTokenQuery,
  useGetPasswordResetIsResetLinkValidByResetIdQuery,
  usePostPasswordResetRequestByUserEmailMutation,
  usePostPasswordResetResetPasswordMutation,
  usePatchPayoutDetailsByIdMutation,
  useGetPayoutDetailsByUserIdQuery,
  usePostPayoutDetailsMutation,
  useGetPayoutDetailsQuery,
  useGetPingQuery,
  useGetPortsCountQuery,
  usePutPortsByIdMutation,
  usePatchPortsByIdMutation,
  useGetPortsByIdQuery,
  useDeletePortsByIdMutation,
  usePostPortsMutation,
  usePatchPortsMutation,
  useGetPortsQuery,
  useGetPropertiesCountQuery,
  usePostPropertiesDenyByIdMutation,
  useGetPropertiesLocationsQuery,
  useGetPropertiesManagerPropertiesQuery,
  useGetPropertiesUnverifiedQuery,
  useGetPropertiesVerifiedManagerWithBookingsQuery,
  usePostPropertiesVerifyByIdMutation,
  usePutPropertiesByIdMutation,
  usePatchPropertiesByIdMutation,
  useGetPropertiesByIdQuery,
  useDeletePropertiesByIdMutation,
  usePostPropertiesMutation,
  usePatchPropertiesMutation,
  useGetPropertiesQuery,
  usePostRemoveCalendarByIdAndBookableTypeMutation,
  useGetRoutesCountQuery,
  usePutRoutesByIdMutation,
  usePatchRoutesByIdMutation,
  useGetRoutesByIdQuery,
  useDeleteRoutesByIdMutation,
  usePostRoutesMutation,
  usePatchRoutesMutation,
  useGetRoutesQuery,
  useGetSentEmailsCountQuery,
  useGetSentEmailsQuery,
  usePostSetCalendarAuthByIdAndBookableTypeCodeMutation,
  useGetSitemapBookablesQuery,
  useGetSkippersCountQuery,
  usePutSkippersByIdMutation,
  usePatchSkippersByIdMutation,
  useGetSkippersByIdQuery,
  useDeleteSkippersByIdMutation,
  usePostSkippersMutation,
  usePatchSkippersMutation,
  useGetSkippersQuery,
  usePostStripeConnectAccountLoginLinkMutation,
  usePostStripeConnectAccountSyncMutation,
  usePostStripeConnectAccountMutation,
  useGetStripeConnectAccountQuery,
  useGetStripeConnectAccountsByIdBookablesQuery,
  usePostStripeConnectAccountsByIdDisableMutation,
  usePatchStripeConnectAccountsByIdRoutingMutation,
  usePostStripeConnectAccountsByIdSyncMutation,
  usePostStripeConnectAccountsMutation,
  useGetStripeConnectAccountsQuery,
  useGetStripeConnectBookingsByIdChargesQuery,
  usePostStripeConnectBookingsByIdRefundMutation,
  usePostStripeConnectBookingsByIdReleasePayoutMutation,
  useGetStripeConnectUsersSearchQuery,
  usePostStripeConnectWebhookMutation,
  usePostStripeWebhookMutation,
  usePostSubmitReviewMutation,
  usePostSyncCalendarByIdAndBookableTypeMutation,
  useGetTrackEmailOpenByEmailLogIdQuery,
  usePostUserReviewsDenyByIdMutation,
  useGetUserReviewsUnverifiedQuery,
  usePostUserReviewsVerifyByIdMutation,
  useGetUsersBookableIdQuery,
  usePostUsersConfirmEmailMutation,
  useGetUsersCountQuery,
  usePostUsersDenyByUserIdMutation,
  useGetUsersInfoByUserIdQuery,
  usePostUsersLoginMutation,
  usePostUsersLogoutMutation,
  usePostUsersMeConsentMutation,
  useGetUsersMeConsentQuery,
  useGetUsersMeQuery,
  usePostUsersRequestOwnerAuthorisationMutation,
  usePostUsersResendConfirmEmailMutation,
  usePostUsersResetPasswordMutation,
  useGetUsersSearchBySearchQuery,
  useGetUsersUnverifiedQuery,
  usePostUsersUpdateProfilePictureMutation,
  usePostUsersUpdateUserInfoMutation,
  useGetUsersUserPrivateReviewsQuery,
  useGetUsersUserReviewsByUserIdQuery,
  usePostUsersVerifyByUserIdMutation,
  useGetUsersByUserIdConversationsQuery,
  usePutUsersByUserIdMutation,
  useGetUsersByUserIdQuery,
  usePostUsersMutation,
  useGetVehiclesCountQuery,
  useGetVehiclesLocationsQuery,
  useGetVehiclesManagerVehiclesQuery,
  usePostVehiclesRejectByIdMutation,
  useGetVehiclesUnverifiedQuery,
  useGetVehiclesVerifiedManagerWithBookingsQuery,
  usePostVehiclesVerifyByIdMutation,
  usePutVehiclesByIdMutation,
  usePatchVehiclesByIdMutation,
  useGetVehiclesByIdQuery,
  useDeleteVehiclesByIdMutation,
  usePostVehiclesMutation,
  useGetVehiclesQuery,
  useGetWhoAmIQuery,
  useGetByBookableTypeAndSlugQuery,
} = injectedRtkApi;
